window._SITE_ = window.location.hostname == 'jp.florasis.com' ? 'jp' : 'en'
window._LANGUAGE_ = document.querySelector('html').getAttribute('lang') || 'en'
;(function () {
  const urlParams = new URLSearchParams(window.location.search)
  const myParam = urlParams.get('openCart')
  if (myParam && myParam === '1') {
    let cartDrawer = document.querySelector('#cart-drawer')
    if (cartDrawer) {
      cartDrawer.setAttribute('open', '')
    }
  }
  if (window.location.pathname === '/collections/summer-2023') {
    document.querySelector('body').classList.add('bg-summer-2023')
  }
})()

document.addEventListener('DOMContentLoaded', function () {
  var lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'))
  if ('IntersectionObserver' in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source]
            if (
              typeof videoSource.tagName === 'string' &&
              videoSource.tagName === 'SOURCE'
            ) {
              videoSource.src = videoSource.dataset.src
            }
          }

          video.target.load()
          video.target.classList.remove('lazy')
          lazyVideoObserver.unobserve(video.target)
        }
      })
    })

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo)
    })
  }
  // 因为有全局 lottery ， 所以需要初始化加载
  ReactLoader.loadResource()

  if (
    window.location.pathname !== '/pages/rewards-for-referrals' &&
    window._SITE_ != 'jp'
  ) {
    ReactLoader.loadCommonDialogScript()
  }
})

window.moneyFormat = function (price) {
  // FIXME: multiple money format
  if (window._SITE_ == 'jp') {
    return `¥${price} ${window.Shopify.currency['active']}`
  } else {
    return `$${price} ${window.Shopify.currency['active']}`
  }
}
const couponId = window._SITE_ == 'jp' ? 100011 : 100010
function isValidTime(begin, end) {
  let beginTimeStamp = new Date(begin).getTime()
  let endTimeStamp = new Date(end).getTime()
  let now = Date.now()
  return now >= beginTimeStamp && now <= endTimeStamp
}

let couponProductEn = isValidTime(
  '2025-01-15T06:00:00.000Z',
  '2026-10-01T06:00:00.000Z'
)
  ? '44769904066759|44769912881351|44769912914119|44769904099527|44769912946887|44769912979655|44769920450759|44769924874439|44769932378311|44769925497031|44769924972743|44769925005511|44769932804295|44769925628103|44769932902599|44769926250695|44769926283463|44769925202119|44769925234887|44769925824711|44769925857479|44769932935367|44769926480071|44769926512839|44769901805767|44769901838535|44769901871303|44769901904071|44769901936839|44769919205575|44769919238343|44769919271111|44769919369415|44812904169671|44813052477639|44812658114759|44812711198919|44812761530567|44812770574535|44809397141703|44809397174471|44809397207239|44818798739655|44818798772423|44818798805191|44809437479111|44809437511879|44809437544647|44809437577415|44809437610183|44809488171207|44809473556679|44809473589447|44809475326151|44809473622215|44809473654983|44809473687751|44809475358919|44809473720519|44809491513543'.split(
      '|'
    )
  : []
let couponProductJp = isValidTime(
  '2025-01-15T15:00:00.000Z',
  '2025-02-14T16:00:00.000Z'
)
  ? [
      '43726739505334',
      '43726847410358',
      '43726861009078',
      '43726864154806',
      '43726926807222',
      '43726927069366',
      '43726927200438',
    ]
  : []
/**
 *
 * @param {Array<{id:string,quantity:number,properties:Object}>} items 产品数组
 * @param {HTMLElement} btnDom 加购的元素
 * @param {boolean} needOpenCart 购物车是否打开
 * @returns
 */
window.addToCart = function (items, btnDom, needOpenCart = true) {
  // variantId
  let bindingCoupons = [...couponProductEn, ...couponProductJp]
  for (let i = 0; i < items.length; i++) {
    if (bindingCoupons.includes(String(items[i].id))) {
      if (items[i].properties) {
        items[i].properties = {
          ...items[i].properties,
          _bf: true,
          _presentId: couponId,
        }
      } else {
        items[i].properties = {
          _bf: true,
          _presentId: couponId,
        }
      }
    }
  }
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      items: items,
    }),
  })
    .then(res => res.json())
    .then(res => {
      if (res.items) {
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        )
        // 打开购物车
        cartToggle(true)
        if (btnDom) {
          btnDom.removeAttribute('disabled')
        }
      }
    })
}

// 加载脚本
function loadScript(url, options, callback) {
  var script = document.createElement('script')
  script.type = 'text/javascript'
  if (typeof callback !== 'undefined') {
    script.onload = function () {
      callback()
    }
  }
  script.src = url
  if (options) {
    for (let key in options) {
      script.setAttribute(key, options[key])
    }
  }
  if (window.requestIdleCallback && typeof requestIdleCallback == 'function') {
    requestIdleCallback(
      () => {
        document.body.appendChild(script)
      },
      { timeout: 2000 }
    )
  } else {
    document.body.appendChild(script)
  }
}
// 加载css
function loadStyle(url, callback) {
  var link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = url
  document.getElementsByTagName('head')[0].appendChild(link)
  link.addEventListener(
    'load',
    function () {
      callback && callback()
    },
    false
  )
}

// 三方可延迟脚本加载
// window.addEventListener('load', function () {
//   if (window.requestIdleCallback && typeof requestIdleCallback == 'function') {
//     requestIdleCallback(
//       () => {
//         idleLoad()
//       },
//       { timeout: 3000 }
//     )
//   } else {
//     idleLoad()
//   }
//   // Zendesk: 在线客服对话插件
//   function idleLoad() {
//     const zendeskUrl =
//       window._SITE_ == 'jp'
//         ? 'https://static.zdassets.com/ekr/snippet.js?key=8b9e189f-bb4f-4ff6-959b-d36db647770c'
//         : 'https://static.zdassets.com/ekr/snippet.js?key=a456ee2b-1e86-4168-a6c5-f2438e56e10b'
//     loadScript(zendeskUrl, { id: 'ze-snippet', defer: '' })
//     if (window._SITE_ != 'jp') {
//       loadScript('https://static.myshlf.us/Affiliates/sms_aff_clicktrack.js', {
//         defer: '',
//       })
//       // loadScript('https://app.certainly.io/sdk/webchat.js', {}, () => {
//       //   initCertainlyWidget({
//       //     id: '26e1ed59-a205-4c0c-9ab5-f582aca1004d',
//       //   })
//       // })
//     }
//     loadCssFactory('react-toastify')
//     loadCssFactory('react-photo-view')
//   }
// })

const lazyCss = {
  'react-toastify': {
    id: 'react-toastify-css',
    callbacks: [],
    status: 'unload', // unload | loading | loaded | error
  },
  'react-photo-view': {
    id: 'react-photo-view-css',
    callbacks: [],
    status: 'unload', // unload | loading | loaded | error
  },
}

// css 加载工厂
function loadCssFactory(name, callback, errorCallback) {
  let target = lazyCss[name]
  if (!target || target.status === 'error') {
    console.log(`css ${name} is not exist`)
    errorCallback && errorCallback()
    return
  }
  if (target.status === 'loaded') {
    callback && callback()
    errorCallback && errorCallback()
    return
  }
  if (target.status === 'loading') {
    target.callbacks.push(callback)
    errorCallback && errorCallback()
    return
  }
  target.status = 'loading'
  target.callbacks.push(callback)
  let styleDom = document.querySelector(`#${target.id}`)
  if (!styleDom) {
    console.warn(`${target.id} is not import`)
    target.status = 'error'
    errorCallback && errorCallback()
    return
  }
  let url = styleDom.getAttribute('url')
  if (!url) {
    console.warn(`${target.id} url is not write`)
    target.status = 'error'
    errorCallback && errorCallback()
    return
  }
  loadStyle(url, () => {
    target.status = 'loaded'
    target.callbacks.forEach(cb => {
      cb && cb()
    })
  })
}

class ReactLoader {
  static loadReactScript() {
    return new Promise((resolve, reject) => {
      if (
        window.React &&
        window.ReactDOM &&
        window.ReactDOM.createRoot &&
        window.engravingProduct &&
        window.quickShop
      ) {
        resolve()
      }
      if (!window.React || !window.ReactDOM || !window.ReactDOM.createRoot) {
        const allPromises = []
        if (!window.React) {
          allPromises.push(this.loadPromise('react'))
        }
        if (!window.ReactDOM || !window.ReactDOM.createRoot) {
          allPromises.push(this.loadPromise('react-dom'))
        }
        Promise.all(allPromises)
          .then(() => {
            const nextPromises = [
              this.loadPromise('sku-drawer'),
              this.loadPromise('engraving'),
              // this.loadPromise('lottery'),
              // this.loadPromise('christmas-game-modal'),
            ]
            return Promise.all(nextPromises).then(() => {
              resolve()
            })
          })
          .catch(err => {
            reject(err)
            console.log('react resource fail', err)
          })
      } else {
        const allPromises = []
        if (!window.engravingProduct) {
          allPromises.push(this.loadPromise('engraving'))
        }
        if (!window.quickShop) {
          allPromises.push(this.loadPromise('sku-drawer'))
        }
        // 全局
        // allPromises.push(this.loadPromise('lottery'))
        // allPromises.push(this.loadPromise('christmas-game-modal'))
        return Promise.all(allPromises).then(() => {
          resolve()
        })
      }
    })
  }

  static loadCommonDialogScript() {
    return new Promise((resolve, reject) => {
      if (window.React && window.ReactDOM && window.ReactDOM.createRoot) {
        resolve()
      }
      if (!window.React || !window.ReactDOM || !window.ReactDOM.createRoot) {
        const allPromises = []
        if (!window.React) {
          allPromises.push(this.loadPromise('react'))
        }
        if (!window.ReactDOM || !window.ReactDOM.createRoot) {
          allPromises.push(this.loadPromise('react-dom'))
        }
        Promise.all(allPromises)
          .then(() => {
            const nextPromises = [this.loadPromise('common-dialog')]
            return Promise.all(nextPromises).then(() => {
              resolve()
            })
          })
          .catch(err => {
            reject(err)
            console.log('loadCommonDialogScript fail', err)
          })
      } else {
        const allPromises = []
        allPromises.push(this.loadPromise('common-dialog'))
        return Promise.all(allPromises).then(() => {
          resolve()
        })
      }
    })
  }

  static loadReactCss() {
    return new Promise((resolve, reject) => {
      let promise_1 = new Promise((res, rej) => {
        loadCssFactory('react-photo-view', res, rej)
      })
      let promise_2 = new Promise((res, rej) => {
        loadCssFactory('react-toastify', res, rej)
      })
      Promise.all([promise_1, promise_2])
        .then(() => {
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  }
  static loadResource(callback) {
    if (!this.fn) {
      this.fn = []
    }
    if (ReactLoader.loading) {
      this.fn && this.fn.push(callback)
      return
    }
    if (ReactLoader.loaded) {
      callback && callback()
      return
    }
    ReactLoader.loading = true
    this.fn.push(callback)
    const allPromises = []
    allPromises.push(this.loadReactScript())
    allPromises.push(this.loadReactCss())
    Promise.all(allPromises)
      .then(() => {
        ReactLoader.loaded = true
        ReactLoader.loading = false
        this.fn &&
          this.fn.forEach(fn => {
            fn && fn()
          })
        this.fn = []
      })
      .catch(err => {
        ReactLoader.loaded = false
        ReactLoader.loading = false
        console.log('react resource fail', err)
      })
  }
  static loadPromise(id) {
    id = id + '-script'
    return new Promise((resolve, reject) => {
      try {
        const target = document.querySelector('#' + id)
        if (!target) throw new Error(`${id} is not import`)
        const src = target.getAttribute('url')
        if (!src) throw new Error(`${id} url is not write`)
        loadScript(src, null, () => {
          resolve()
        })
      } catch (error) {
        reject(error)
      }
    })
  }
}
window.ReactLoader = ReactLoader

window.editEngraving = function (...args) {
  ReactLoader.loadResource(() => {
    window.editEngraving(...args)
  })
}

window.removeEngraving = function (...args) {
  ReactLoader.loadResource(() => {
    window.removeEngraving(...args)
  })
}
/**
 * 应用折扣码-旧版，shopify已不支持
 * @param code code码
 * @param productId 商品id
 * @deprecated
 */
// window.applyCode = function (code, productId) {
//   return new Promise((resolve, reject) => {
//     fetch('/payments/config', { method: 'GET' })
//       .then(function (response) {
//         return response.json()
//       })
//       .then(function (data) {
//         const checkout_json_url = '/wallets/checkouts/'
//         let authorization_token = btoa(data.paymentInstruments.accessToken)
//         fetch('/cart.js', {})
//           .then(function (res) {
//             return res.json()
//           })
//           .then(function (data) {
//             let line_items = data.items
//             if (productId) {
//               line_items = line_items.filter(item => {
//                 return item.product_id == Number(productId)
//               })
//             }
//             let body = {
//               checkout: {
//                 country: window.Shopify.country,
//                 discount_code: code,
//                 line_items: line_items,
//                 presentment_currency: window.Shopify.currency.active,
//               },
//             }
//             fetch(checkout_json_url, {
//               headers: {
//                 accept: '*/*',
//                 'cache-control': 'no-cache',
//                 authorization: 'Basic ' + authorization_token,
//                 'content-type': 'application/json, text/javascript',
//                 pragma: 'no-cache',
//                 'sec-fetch-dest': 'empty',
//                 'sec-fetch-mode': 'cors',
//                 'sec-fetch-site': 'same-origin',
//               },
//               referrerPolicy: 'strict-origin-when-cross-origin',
//               method: 'POST',
//               mode: 'cors',
//               credentials: 'include',
//               body: JSON.stringify(body),
//             })
//               .then(function (response) {
//                 return response.json()
//               })
//               .then(function (data) {
//                 if (
//                   data.checkout &&
//                   data.checkout.applied_discounts.length > 0
//                 ) {
//                   let discountApplyUrl =
//                     '/discount/' +
//                     code +
//                     '?v=' +
//                     Date.now() +
//                     '&redirect=/checkout/'
//                   fetch(discountApplyUrl, {})
//                     .then(function (response) {
//                       refreshCart(false)
//                       resolve(void 0)
//                     })
//                     .catch(err => {
//                       reject('discountApplyUrl' + err.message)
//                     })
//                 } else {
//                   reject('apply fail')
//                 }
//               })
//               .catch(err => {
//                 reject('apply fail inner' + err.message)
//               })
//           })
//           .catch(() => {
//             reject('get cart fail')
//           })
//       })
//       .catch(error => {
//         reject('apply fail outter' + error.message)
//       })
//   })
// }

/**
 * 新版，直接应用code，但是不知道结果，需要刷新购物车
 * @param {*} code 折扣码
 */
window.applyCode = async function (code) {
  await fetch(`/discount/${encodeURIComponent(code)}`)
}

function refreshCart(open = true) {
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
  if (open) {
    setTimeout(() => {
      cartToggle(open)
    }, 300)
  }
}
window.refreshCart = refreshCart

/**
 * @param {boolean} show 是否打开购物车
 */
function cartToggle(show) {
  let btn = document.querySelector('a[id="cart_btn"]')
  if (btn) {
    let flag = btn.getAttribute('aria-expanded') == 'true'
    if (flag != show) {
      btn.click()
    }
  }
}
/**
 *
 * @param {Array<string>} items 移除的商品id数组
 * @param {boolean} refresh 是否刷新购物车
 */
window.removeCartProduct = async function (items, refresh) {
  let data = {}
  if (items instanceof Array) {
    data = items.reduce((acc, item) => {
      acc[item] = 0
      return acc
    }, {})
  } else if (typeof items === 'object' && items !== null) {
    data = items
  }

  let sectionsToBundle = []
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    })
  )
  let cartContent = await (
    await fetch(`/cart/update.js`, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        updates: data,
        sections: sectionsToBundle.join(','),
      }),
    })
  ).json()
  if (refresh) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'line-item:change',
          cart: cartContent,
        },
      })
    )
    setTimeout(() => {
      cartToggle(true)
    }, 300)
  }
  return cartContent
}

class HxzCartHandle {
  constructor() {
    /**
     * 相互冲突的产品集合的集合
     * variantId[][]
     */
    this.reflectProductArrays = []
    this.reflectEvents = []
    /** 
     * 购买限制的产品集合的集合
     * {
          variantId: string,
          lowercase: number, // 美分｜日元*100
          excludeBundle: true, // 是否排除组套
          limit: number, // 限制数量,没有则不限制
        }[][]
     */
    this.limitProductArrays = []
    this.limitEvents = []
  }
  // 获取购物车优惠前价格，去掉优惠后价格为0的产品
  // 返回[当前优惠前金额,以及排除组套的金额]
  getCartPreAmount(line_items) {
    if (!line_items || line_items.length == 0) return [0, 0]
    let totalPrice = 0,
      excludePrice = 0
    for (let i = 0; i < line_items.length; i++) {
      let item = line_items[i]
      if (!item.final_line_price == 0) {
        totalPrice += item.original_line_price
        if (!item.properties || !item.properties._isSet) {
          excludePrice += item.original_line_price
        }
      }
    }
    return [totalPrice, excludePrice]
  }
  // 返回[当前优惠后金额,以及排除组套的金额]
  getCartAfterAmount(line_items) {
    if (!line_items || line_items.length == 0) return [0, 0]
    let totalPrice = 0,
      excludePrice = 0
    for (let i = 0; i < line_items.length; i++) {
      let item = line_items[i]
      totalPrice += item.final_line_price
      if (!item.properties || !item.properties._isSet) {
        excludePrice += item.final_line_price
      }
    }
    return [totalPrice, excludePrice]
  }
  // 检查不满足条件商品的移除购物车
  checkInvalid(line_items) {
    const [currentPrice, excludePrice] = this.getCartPreAmount(line_items)
    if (!line_items || line_items.length == 0) return []
    if (this.limitProductArrays.length == 0) return []
    let removeItems = []
    // 限制购买的商品
    for (let i = 0; i < this.limitProductArrays.length; i++) {
      let products = this.limitProductArrays[i]
      line_items.forEach(item => {
        let gift = products.find(gift => gift.variantId == item.variant_id)
        // 如果超出数量限制，那么商品就是非法添加，直接删除即可
        if (gift && gift.limit && item.quantity > gift.limit) {
          removeItems.push(item.variant_id)
          return
        }
        if (gift) {
          let giftPrice = line_items.reduce((acc, item) => {
            if (item.id == gift.variantId) {
              return acc + item.final_price
            } else {
              return acc
            }
          }, 0)
          if (gift.lowercase == 0 && currentPrice - giftPrice <= 0) {
            removeItems.push(gift.variantId)
          } else {
            // 排除组套
            if (gift.excludeBundle) {
              if (getCurrentPrice(gift.lowercase) > excludePrice - giftPrice) {
                removeItems.push(gift.variantId)
              }
            } else {
              if (getCurrentPrice(gift.lowercase) > currentPrice - giftPrice) {
                removeItems.push(gift.variantId)
              }
            }
          }
        }
      })
    }
    // 检查相互冲突的商品
    let variantIds = line_items.map(item => item.variant_id)
    for (let i = 0; i < this.reflectProductArrays.length; i++) {
      let reflectIds = this.reflectProductArrays[i]
      let existingVariantIds = reflectIds.filter(
        id => variantIds.findIndex(vId => vId == id) != -1
      )
      if (existingVariantIds.length > 1) {
        removeItems.push(...existingVariantIds)
      }
    }
    // 去重
    removeItems = Array.from(new Set(removeItems))
    return removeItems
  }
  checkIsValid({ variantId, quantity }, line_items) {
    const [currentPrice, excludePrice] = this.getCartPreAmount(line_items)
    if (this.limitProductArrays.length == 0) return true
    for (let i = 0; i < this.limitProductArrays.length; i++) {
      let products = this.limitProductArrays[i]
      let gift = products.find(gift => gift.variantId == variantId)
      if (gift) {
        let giftPrice = line_items.reduce((acc, item) => {
          if (item.id == gift.variantId) {
            return acc + item.final_price
          } else {
            return acc
          }
        }, 0)
        if (gift.limit && quantity > gift.limit) {
          return false
        }
        if (gift.lowercase == 0 && currentPrice - giftPrice <= 0) {
          return false
        } else {
          // 排除组套
          if (gift.excludeBundle) {
            if (getCurrentPrice(gift.lowercase) > excludePrice - giftPrice) {
              return false
            }
          } else {
            if (getCurrentPrice(gift.lowercase) > currentPrice - giftPrice) {
              return false
            }
          }
        }
      }
    }
    return true
  }
  // 检查是否有冲突的赠品
  checkReflect(currentId, line_items) {
    currentId = Number(currentId)
    if (!line_items || line_items.length == 0) return []
    if (this.reflectProductArrays.length == 0) return []
    let removeItems = []
    for (let i = 0; i < this.reflectProductArrays.length; i++) {
      let reflectIds = this.reflectProductArrays[i]
      // 与当前赠品无关
      if (!reflectIds.includes(currentId)) continue
      let variantIds = line_items.map(item => item.variant_id)
      if (variantIds.includes(currentId)) {
        throw { code: 1, message: '商品已存在' }
      }
      variantIds.forEach(variantId => {
        if (reflectIds.includes(variantId)) {
          removeItems.push(variantId)
        }
      })
    }
    return removeItems
  }
  addReflect(reflectArray, event) {
    if (this.reflectEvents.includes(event)) return
    if (!(reflectArray instanceof Array)) return
    if (!reflectArray || reflectArray.length == 0) return
    this.reflectEvents.push(event)
    this.reflectProductArrays.push(reflectArray.map(item => Number(item)))
  }
  addLimit(limitArray, event) {
    if (this.limitEvents.includes(event)) return
    if (!(limitArray instanceof Array)) return
    if (!limitArray || limitArray.length == 0) return
    this.limitEvents.push(event)
    this.limitProductArrays.push(limitArray)
  }
}

const hxzCartHandle = new HxzCartHandle()
window.hxzCartHandle = hxzCartHandle

// 绑定赠品列表
window.bundleZengpin = window.bundleZengpin ? window.bundleZengpin : []

function customSmoothScroll(element, targetLeft, duration) {
  const startLeft = element.scrollLeft
  const startTime = performance.now()

  function scroll() {
    const currentTime = performance.now() - startTime
    if (currentTime < duration) {
      const progress = currentTime / duration
      const ease = 1 - Math.pow(1 - progress, 3) // 使用缓动函数（这里使用了三次方的缓动）
      const scrollLeft = startLeft + (targetLeft - startLeft) * ease
      element.scrollLeft = scrollLeft
      requestAnimationFrame(scroll)
    } else {
      element.scrollLeft = targetLeft
    }
  }
  requestAnimationFrame(scroll)
}
let changeGiftLoading = false
function checkZengpinPairs(cartItems, initRemoves = []) {
  if (!cartItems || cartItems.length == 0) return
  if (changeGiftLoading) return
  changeGiftLoading = true
  let updateItems = [...initRemoves]
  let newAddItems = []
  for (let i = 0, j = cartItems.length; i < j; i++) {
    // 匹配买赠
    let bItem = window.bundleZengpin.find(
      p => p.productId === cartItems[i].product_id && cartItems[i].quantity > 0
    ) // 买赠主品
    if (bItem) {
      let newBundleZengpin = null

      if (cartItems[i].properties?._customSet) {
        // 对应自定义礼盒的买赠

        newBundleZengpin = cartItems.find(item => {
          return (
            item.variant_id === bItem.zengpinVariant &&
            item.properties?._customSet &&
            item.properties?._setId === cartItems[i].properties?._setId
          )
        })

        if (newBundleZengpin) {
        } else {
          newAddItems.push({
            id: bItem.zengpinVariant,
            quantity: cartItems[i].quantity,
            properties: {
              _customSet: true,
              _setId: cartItems[i].properties?._setId,
              _index: -1,
            },
          })
        }
      } else {
        let newBundleZengpinArr = cartItems.filter(item => {
          return (
            item.variant_id === bItem.zengpinVariant &&
            item.properties?._pairVariantMath === cartItems[i].variant_id
          )
        })
        newBundleZengpin = newBundleZengpinArr[0]
        for (let i = 1; i < newBundleZengpinArr.length; i++) {
          newBundleZengpin.quantity =
            newBundleZengpin.quantity + newBundleZengpinArr[i].quantity
        }
        if (newBundleZengpin) {
          // 匹配数量
          if (newBundleZengpin.quantity !== cartItems[i].quantity) {
            updateItems.push(cartItems[i].key)
            updateItems = updateItems.concat([
              ...newBundleZengpinArr.map(item => item.key),
            ])
            newAddItems.push(
              {
                id: bItem.zengpinVariant,
                quantity: cartItems[i].quantity,
                properties: {
                  _pairVariantMath: cartItems[i].variant_id,
                },
              },
              {
                id: cartItems[i].variant_id,
                quantity: cartItems[i].quantity,
                properties: cartItems[i].properties,
              }
            )
          }
        } else {
          // 没有则增加
          updateItems.push(cartItems[i].key)
          newAddItems.push(
            {
              id: bItem.zengpinVariant,
              quantity: cartItems[i].quantity,
              properties: {
                _pairVariantMath: cartItems[i].variant_id,
              },
            },
            {
              id: cartItems[i].variant_id,
              quantity: cartItems[i].quantity,
              properties: cartItems[i].properties,
            }
          )
        }
      }
    }

    // 匹配赠品
    let zengpinCheck = cartItems[i].properties?._pairVariantMath
    if (zengpinCheck) {
      let hasMainProduct = cartItems.find(
        item => item.variant_id === zengpinCheck
      )
      if (!hasMainProduct) {
        updateItems.push(cartItems[i].key)
      }
    }
  }

  if (updateItems.length > 0) {
    let data = {}
    updateItems.forEach(item => {
      data[item] = 0
    })

    removeCartProduct(data, true)
      .then(() => {
        if (newAddItems.length > 0) {
          window.addToCart(newAddItems, null, true).finally(() => {
            changeGiftLoading = false
          })
        } else {
          changeGiftLoading = false
        }
      })
      .catch(() => {
        changeGiftLoading = false
      })
  } else {
    if (newAddItems.length > 0) {
      window.addToCart(newAddItems, null, true).finally(() => {
        changeGiftLoading = false
      })
    } else {
      changeGiftLoading = false
    }
  }
}

const enGameGifts = [
  // 下面是大转盘礼包
  {
    variantId: 44065586053319, // 43457507623111
    lowercase: 0,
    excludeHarness: false,
    limit: 1,
  },
  {
    variantId: 44065575764167, // 43457507623111
    lowercase: 0,
    excludeHarness: false,
    limit: 1,
  },
  {
    variantId: 44065940308167, // 43457507623111
    lowercase: 0,
    excludeHarness: false,
    limit: 1,
  },
  {
    variantId: 44066784477383, // 43457507623111
    lowercase: 0,
    excludeHarness: false,
    limit: 1,
  },
  {
    variantId: 44067902718151, // 43457507623111
    lowercase: 0,
    excludeHarness: false,
    limit: 1,
  },
]

const jpGameGifts = [
  {
    variantId: 43047484555446, // 43457507623111
    lowercase: 0,
    excludeHarness: false,
    limit: 1,
  },
  // 下面是三级礼包
  {
    variantId: 43047528169654, // 43457507623111
    lowercase: 0, // 日元*100
    excludeHarness: false,
    limit: 1,
  },
  {
    variantId: 43047571292342, // 43457507623111
    lowercase: 0,
    excludeHarness: false,
    limit: 1,
  },
  {
    variantId: 43047577714870, // 43457507623111
    lowercase: 0,
    excludeHarness: false,
    limit: 1,
  },
  {
    variantId: 43047588888758, // 43457507623111
    lowercase: 0,
    excludeHarness: false,
    limit: 1,
  },
]
const gameGifts = window._SITE_ == 'jp' ? jpGameGifts : enGameGifts

hxzCartHandle.addLimit(gameGifts, 'gameGifts')
hxzCartHandle.addReflect(
  gameGifts.map(item => item.variantId),
  'gameGifts'
)
;(function (ns, fetch) {
  if (typeof fetch !== 'function') return

  ns.fetch = function () {
    const response = fetch.apply(this, arguments)
    response.then(res => {
      if (
        [
          // `${window.location.origin}/cart/add.js`,
          `${window.location.origin}/cart/update.js`,
          `${window.location.origin}/cart/change.js`,
          // `${window.location.origin}/cart/clear.js`,
        ].includes(res.url)
      ) {
        res
          .clone()
          .json()
          .then(data => {
            // 处理购物车商品数量为0的情况（update加购售罄的产品时存在）
            if (data.items && data.items.length > 0) {
              data.items = data.items.filter(item => {
                return item.quantity > 0
              })
            }
            let removeItems = [...hxzCartHandle.checkInvalid(data.items)]
            checkZengpinPairs(data.items, removeItems)
            if (changeGiftLoading) return //  并发问题
            if (window.checkQx) {
              window.checkQx(data.items)
            }
          })
      }

      if ([`${window.location.origin}/cart.js`].includes(res.url)) {
        res
          .clone()
          .json()
          .then(data => {
            if (data.items && data.items.length > 50) {
              fetch('/cart/clear.js')
              return
            }
            let removeItems = [...hxzCartHandle.checkInvalid(data.items)]
            checkZengpinPairs(data.items, removeItems)
            if (changeGiftLoading) return //  并发问题
            if (window.checkQx) {
              window.checkQx(data.items)
            }
            if (
              data.note &&
              document.querySelector('cart-drawer .hxz-cart-note')
            ) {
              document.querySelector(
                'cart-drawer .hxz-cart-note span'
              ).innerHTML = data.note
            }
          })
      }
    })
    return response
  }
})(window, window.fetch)

class HXZVariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
    this.querySelector('.hxz-dropdown').addEventListener(
      'click',
      this.onDropdownClick
    )
    this.querySelector('.hxz-dropdown-selected').addEventListener(
      'click',
      this.onToggleDropdown
    )
  }

  async connectedCallback() {
    this.masterSelector = document.forms[this.getAttribute('form')].id

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('variant')) {
      let variantId = urlParams.get('variant')
      this.currentVariant = this.getVariantData().find(variant => {
        return variant.id == variantId
      })
    } else {
      let variants = this.getVariantData()
      if (variants.length > 0) {
        let availableVariant = variants.find(variant => variant.available)
        if (availableVariant) {
          this.currentVariant = availableVariant
        } else {
          this.currentVariant = variants[0]
        }
      } else {
        this.currentVariant = null
      }
    }
  }

  onVariantChange() {
    const previousVariant = this.currentVariant
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.updateDesc()
    this.updateVirtualSkuId()
    this.updateBuyBtn()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
    } else {
      this.updateURL()
      this.updateMedia()
      this.updateDropdown()
      this.updateTopDropdown()
      this.renderProductInfo()
    }

    this.masterSelector.form.dispatchEvent(
      new CustomEvent('variant:change', {
        bubbles: true,
        detail: {
          product: selfProduct,
          variant: this.currentVariant,
          previousVariant,
        },
      })
    )
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      select => select.value
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateDropdown() {
    const dropdown = this.querySelector('.hxz-dropdown-selected')
    this.querySelector('.hxz-dropdown-selected-content').innerHTML =
      this.querySelector('.hxz-dropdown').querySelector(
        `div[data-value="${this.currentVariant.option1}"]`
      ).innerHTML
  }

  updateTopDropdown() {
    const dropdown = document.querySelector(
      `hxz-pd-top-dropdown .dropdown-option[data-value="${this.currentVariant.option1}"]`
    )
    if (dropdown) {
      document.querySelector(
        'hxz-pd-top-dropdown .dropdown-selection'
      ).innerHTML = dropdown.innerHTML
    }
  }

  onToggleDropdown(e) {
    const dropDown = this.closest('.hxz-dropdown-container').querySelector(
      '.hxz-dropdown'
    )
    if (dropDown.style.display === 'none') {
      dropDown.style.display = 'block'
    } else {
      dropDown.style.display = 'none'
    }
  }

  updateBuyBtn() {
    if (this.currentVariant.available) {
      document.querySelectorAll('hxz-buy-btn').forEach(btn => {
        btn.setBtnStatus(true)
      })
    } else {
      document.querySelectorAll('hxz-buy-btn').forEach(btn => {
        btn.setBtnStatus(false)
      })
    }
  }

  onDropdownClick(e) {
    let el = e.target.closest('.hxz-dropdown-variant')
    let rootEl = e.target.closest('hxz-variant-radios')
    let value = el.dataset.value
    let input = rootEl.querySelector('input[value="' + value + '"]')
    if (input.nextElementSibling) {
      input.nextElementSibling.click()
      this.style.display = 'none'
      rootEl.querySelector('.hxz-dropdown').style.display = 'none'
      rootEl.querySelector('.hxz-dropdown-selected-content').innerHTML =
        el.innerHTML
    }
  }

  getCurrentVariant() {
    return this.currentVariant
  }

  updateDesc() {
    const skuDescs = JSON.parse(
      this.querySelector('#product-desc[type="application/json"]').textContent
    )
    this.querySelector('.p-desc').innerHTML = skuDescs[this.currentVariant.id]

    this.querySelector('.p-label-value').innerHTML = this.currentVariant.title
  }

  /**
   * 仅仅是给 hxz-virtual-makeup 使用的
   * @returns {null | {variantId:'加购id',hasVirtual: 1, skuId: "试妆id", type: "妆容数量", price: "", available: boolean}}
   */
  getVirtualSkuId() {
    const json = this.querySelector('#product-virtual[type="application/json"]')
    if (json) {
      if (!this.virtualSkuIds) {
        this.virtualSkuIds = JSON.parse(json.textContent)
      }
      let value = this.virtualSkuIds[this.currentVariant.id]
      return {
        ...value,
        hasVirtual: value.hasVirtual == '1',
        variantId: this.currentVariant.id,
      }
    }
    return null
  }
  // 仅仅是给 hxz-virtual-makeup 使用的
  getVirtualSkuList() {
    const json = this.querySelector('#product-virtual[type="application/json"]')
    if (json) {
      if (!this.virtualSkuIds) {
        this.virtualSkuIds = JSON.parse(json.textContent)
      }
      let list = Object.keys(this.virtualSkuIds).map(key => {
        return {
          hasVirtual: this.virtualSkuIds[key].hasVirtual == '1',
          name: this.virtualSkuIds[key].name,
          variantId: key, // 加购的id
          type: this.virtualSkuIds[key].type,
          skuId: this.virtualSkuIds[key].skuId, // 试妆的id
          price: this.virtualSkuIds[key].price,
          available: this.virtualSkuIds[key].available,
          skuColor: this.virtualSkuIds[key].skuColor,
          skuImage: this.virtualSkuIds[key].skuImage,
          familyPrice: this.virtualSkuIds[key].familyPrice,
        }
      })
      return list
    }
    return []
  }
  // 仅仅是给 hxz-virtual-makeup 使用的
  updateVirtualSkuId() {
    const virtualSku = this.getVirtualSkuId()
    if (!virtualSku) return
    window.dispatchEvent(
      new CustomEvent('virtual:sku-change', {
        detail: {
          skuId: virtualSku.skuId,
          type: virtualSku.type,
          hasVirtual: virtualSku.hasVirtual == '1',
          price: virtualSku.price,
          available: virtualSku.available,
          variantId: virtualSku.variantId,
          name: virtualSku.name,
        },
      })
    )
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    if (window.innerWidth < 1000) {
      let domm = document.querySelector(
        `.hxz-pd-medias [data-media-id="${this.currentVariant.featured_media.id}"]`
      )
      if (!domm) return
      const y = domm.offsetLeft - 16
      document
        .querySelector('.hxz-pd-medias')
        .scrollTo({ left: y, behavior: 'smooth' })
    }
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
    const hxzProductGallery = document.querySelector('hxz-product-gallery')
    if (hxzProductGallery) {
      hxzProductGallery.setAttribute('current-id', this.currentVariant.id)
    }
    const hxzInfoScrollable = document.querySelector('hxz-info-scrollable')
    if (hxzInfoScrollable) {
      hxzInfoScrollable.setAttribute('current-id', this.currentVariant.id)
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value')
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value')
        )
      }
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then(response => response.text())
      .then(responseText => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        )
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        )
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        )

        if (source && destination) destination.innerHTML = source.innerHTML
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML
          skuDestination.classList.toggle(
            'visibility-hidden',
            skuSource.classList.contains('visibility-hidden')
          )
        }

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'visibility-hidden',
            inventorySource.innerText === ''
          )
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      addButtonText.textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

/**
 * 移除购物车幽灵项
 * @param {string} items 幽灵项节点，以 | 分割
 */
class GhostItems extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    let items = this.getAttribute('items')
    console.log('items', items)
    if (items) {
      let itemArr = items.split('|').filter(item => item)
      if (itemArr.length > 0) {
        console.log('itemArr', itemArr)
        fetch(`/cart/update.js`, {
          method: 'post',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            updates: itemArr.reduce((acc, item) => {
              acc[item] = 0
              return acc
            }, {}),
          }),
        })
      }
    }
    this.remove()
  }
}

customElements.define('hxz-ghost-items', GhostItems)

function windowLoading(flag = false) {
  if (flag) {
    document.documentElement.dispatchEvent(
      new CustomEvent('theme:loading:start', { bubbles: true })
    )
  } else {
    document.documentElement.dispatchEvent(
      new CustomEvent('theme:loading:end', { bubbles: true })
    )
  }
}
window.windowLoading = windowLoading

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

/**
 *
 * @param {object} update 操作的购买项数据{key:string,quantity:number} | { [variantId]:quantity }
 * @param {string} actionType 操作的类型，remove,decrease,plus,quantityChange,add
 * @param {Array} lineItems 传入购物车项目信息
 * todo： 后续要接通产品埋点
 */
async function cartChangeBefore(
  update = {},
  actionType,
  lineItems = undefined
) {
  // 成功的code = 1
  let result = { code: 1, message: 'success' }
  try {
    let updates = {},
      removeItem = [],
      targets = []
    if (update.key) {
      targets.push({ key: update.key, quantity: update.quantity })
    } else {
      if (isObject(update)) {
        targets = Object.keys(update).map(key => ({
          key,
          quantity: update[key],
        }))
      } else {
        targets = update
      }
    }
    // 移除掉无效的key
    targets = targets.filter(item => item.key)

    windowLoading(true)
    let items = []
    if (lineItems !== undefined) {
      items = lineItems
    } else {
      const cartData = await fetch('/cart.js').then(res => res.json())
      items = cartData.items
    }

    for (let i = 0; i < targets.length; i++) {
      let target = targets[i]
      let res = singleCheck(target, actionType, items)
      targets[i] = res.target
      removeItem = [...removeItem, ...res.removeItems]
    }
    // 过滤无效的操作
    targets = targets.filter(item => item)
    if (targets.length == 0 && removeItem.length == 0) {
      windowLoading(false)
      return { code: 100, message: '无效的操作' }
    }
    if (actionType == 'add') {
      if (removeItem.length > 0) {
        removeItem.forEach(item => {
          updates[item.variantId] = 0
        })
         await removeCartProduct(updates, true)
      }
      await window.addToCart(
        targets.map(item => ({
          id: item.key,
          quantity: item.quantity,
        }))
      )
      
    } else {
      targets.forEach(item => {
        updates[item.key] = item.quantity
      })
      // 同时将重复id合并
      removeItem.forEach(item => {
        updates[item.variantId] = 0
      })
      await removeCartProduct(updates, true)
    }

    windowLoading(false)
    return result
  } catch (error) {
    console.log('err', error)
    // 重新加载网站
    window.location.reload()
    document.documentElement.dispatchEvent(
      new CustomEvent('theme:loading:end', { bubbles: true })
    )
  }
}
/**
 * 单个产品的检测，同时返回最新的更新数据
 * @param {{key:string,quantity:number}} target 当前检测的产品
 * @param {string} actionType 操作类型
 * @param {Array} items 购物车现有产品数组
 * @returns {{target:{},removeItems:[{variantId:string,quantity:number}]}} target为null表示改操作无效，removeItems为需要移除的产品
 */
function singleCheck(target, actionType, items) {
  let removeItems = []
  if (actionType == 'remove') {
    if (items.length > 1) {
      let filterItems = items.filter(item => item.key != target.key)
      let ids = hxzCartHandle.checkInvalid(filterItems)
      removeItems = ids.map(id => ({ variantId: id, quantity: 0 }))
    }
  }
  if (actionType == 'decrease' || actionType == 'quantityChange') {
    // 数量改变是针对line的key
    let line = items.find(item => item.key == target.key)
    if (line) {
      line.quantity = target.quantity
      line.original_line_price = line.original_price * target.quantity
      let ids = hxzCartHandle.checkInvalid(items)
      if (ids.length > 0) {
        for (let i = 0; i < ids.length; i++) {
          let id = ids[i]
          // 说明当前操作存在问题或非法
          if (id == line.variant_id) {
            // 删除当前操作目标
            target = null
            // 不进行判断
            ids = []
            break
          }
        }
      }
      removeItems = ids.map(id => ({ variantId: id, quantity: 0 }))
    }
  }
  if (actionType === 'add') {
    // 检查是否可以添加
    let isCanAdd = hxzCartHandle.checkIsValid(
      { variantId: target.key, quantity: target.quantity },
      items
    )
    if (!isCanAdd) {
      target = null
    } else {
      let ids = hxzCartHandle.checkReflect(target.key, items)
      if (ids.length > 0) {
        // 添加产品时存在冲突产品，自动移除冲突产品
        removeItems = ids.map(id => ({ variantId: id, quantity: 0 }))
      }
      // 检查是否有相同的产品，将产品合并 update
      // let sameItem = items.find(item => item.variant_id == target.key)
      // if (sameItem) {
      //   target.quantity = target.quantity + sameItem.quantity
      // }
    }
  }
  return {
    target,
    removeItems,
  }
}
window.cartChangeBefore = cartChangeBefore

customElements.define('hxz-variant-selects', HXZVariantSelects)

class HXZVariantRadios extends HXZVariantSelects {
  constructor() {
    super()
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled')
      } else {
        input.classList.add('disabled')
      }
    })
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        radio => radio.checked
      ).value
    })
  }

  getSelectedValue() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    const value = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        radio => radio.checked
      ).value
    })
    return value
  }

  getSelectedSkuid() {
    const value = this.getSelectedValue()
    if (!value || value.length === 0) return null
    const variantDatas = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    )
    let selectedSkuId = variantDatas.find(item => item.option1 === value[0])
    if (selectedSkuId) {
      return selectedSkuId.id
    }
    return null
  }
  getSelectedSku() {
    const value = this.getSelectedValue()
    if (!value || value.length === 0) return null
    const variantDatas = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    )
    let selectedSkuId = variantDatas.find(item => item.option1 === value[0])
    if (selectedSkuId) {
      return selectedSkuId.sku
    }
    return null
  }
}

customElements.define('hxz-variant-radios', HXZVariantRadios)

class HXZProductCard extends HTMLElement {
  constructor() {
    super()
    // 加购
    this.querySelector('.hxz-cart-btn')?.addEventListener('click', e => {
      e.stopPropagation()
      e.preventDefault()
      ReactLoader.loadResource.bind(ReactLoader, this.addToCart.bind(this))()
      // this.loadResource.bind(this, this.addToCart)()
    })
    // 刻字
    this.querySelector('.engraving')?.addEventListener('click', e => {
      e.stopPropagation()
      e.preventDefault()
      ReactLoader.loadResource.bind(ReactLoader, this.engraving.bind(this))()
      // this.loadResource.bind(this, this.addToCart)()
    })
    // 自定义礼盒
    let customBtn = this.querySelector('.hxz-custom-gift-btn')
    if (customBtn) {
      customBtn.addEventListener(
        'click',
        // this.loadResource.bind(this, this.selectCustomProduction)
        ReactLoader.loadResource.bind(
          ReactLoader,
          this.selectCustomProduction.bind(this)
        )
      )
    }
    this.lightning = this.querySelector('hxz-lightning')
    this.quickSkuId = null
    this.quickSkuTitle = undefined
  }

  quickShopAdd(data, variantId) {
    window.addToCart(data)
  }

  addToCart() {
    const rootEl = this.closest('hxz-product-card')

    if (rootEl.dataset.multiple === '1') {
      window.quickShop(
        rootEl.dataset.productId,
        rootEl,
        this.quickSkuId ? { _selectedSku: this.quickSkuId } : {}
      )
      return
    }
    const data = [
      {
        quantity: 1,
        id: rootEl.dataset.skuId,
      },
    ]

    window.addToCart(data)
  }
  selectCustomProduction() {
    const rootEl = this.closest('hxz-product-card')
    if (rootEl.dataset.multiple === '1') {
      window.quickShop(rootEl.dataset.productId, rootEl, { isSelect: true })
      return
    }

    const price = rootEl.dataset.price
    const delPrice = rootEl.dataset.delPrice
    window.selectCustomProduction({
      id: rootEl.dataset.skuId,
      properties: {},
      price: price,
      delPrice: delPrice,
      title: rootEl.dataset.title,
      cover: rootEl.dataset.cover,
      productId: rootEl.dataset.productId,
      subtitle: '',
    })
  }
  connectedCallback() {
    this.addEventListener('mouseover', this.mouseBinding)
    // 检查是否是ipad 或 移动端
    if (window.innerWidth < 1000) {
      this.observe()
    }
    this.quickSkuSelect()
  }
  mouseBinding() {
    ReactLoader.loadResource()
    this.removeEventListener('mouseover', this.mouseBinding)
  }
  observe() {
    const observer = new IntersectionObserver((entries, observer) => {
      // 当目标元素进入视口时，打印 1
      if (entries[0].isIntersecting) {
        this.mouseBinding()
        // 停止观察目标元素
        observer.unobserve(this)
      }
    })
    // 开始观察目标元素
    observer.observe(this)
  }

  quickSkuSelect() {
    const rootEl = this.closest('hxz-product-card')
    let price_before_change = rootEl.dataset.price
    const options = this.querySelectorAll('.p-option')
    if (options && options.length > 0) {
      options.forEach(item => {
        item.addEventListener('click', () => {
          this.quickSkuId = Number(item.getAttribute('data-variant-id'))
          this.quickSkuTitle = item.getAttribute('title')
          if (this.lightning) {
            this.lightning.setAttribute(
              'default-sku',
              item.getAttribute('data-variant-sku')
            )
          }
          if (item.classList.contains('active')) {
            item.classList.remove('active')
            let grandparent = item.parentNode.parentNode
            let previousSibling = grandparent.previousElementSibling
            if (previousSibling) {
              let cImgElement = previousSibling.querySelector('.c-img')
              if (cImgElement) {
                cImgElement.style.opacity = '0'
              }
            }
            let obj = item.parentNode.previousElementSibling
            let price_box = obj
              .querySelector('.hxz-prodcard-price')
              .querySelector('.show-money')
            const dollar_box = price_box.querySelector('.money')
            if (dollar_box) {
              dollar_box.innerHTML = price_before_change
            } else {
              price_box.innerHTML = price_before_change
            }
          } else {
            let url = item.getAttribute('data-change')
            let price = item.getAttribute('data-price')
            let obj = item.parentNode.previousElementSibling
            let grandparent = item.parentNode.parentNode
            let previousSibling = grandparent.previousElementSibling
            if (previousSibling) {
              let cImgElement = previousSibling.querySelector('.c-img')
              if (cImgElement) {
                cImgElement.setAttribute('src', url)
                cImgElement.style.opacity = '1'
              }
            }

            let price_box = obj
              .querySelector('.hxz-prodcard-price')
              .querySelector('.show-money')
            const dollar_box = price_box.querySelector('.money')
            if (dollar_box) {
              dollar_box.innerHTML = price
            } else {
              price_box.innerHTML = price
            }
            let siblings = Array.from(item.parentNode.children)
            siblings.forEach(function (sibling) {
              if (sibling !== item) {
                sibling.classList.remove('active')
              }
            })
            item.classList.add('active')
          }
        })
      })
    }
  }
  engraving() {
    const productId = this.getAttribute('data-engraving-product-id')
    const feeId = this.getAttribute('data-fee-id')
    if (!productId || !feeId) {
      throw new Error('productId or feeId is null')
    }
    const variantInfo = JSON.parse(
      this.querySelector('#engraving-variants-metafields').textContent.slice(
        0,
        -1
      ) || '{}'
    )
    const isSelect = this.getAttribute('data-select') == 'true'
    window.engravingProduct(
      productId,
      feeId,
      variantInfo,
      this.quickSkuTitle,
      undefined,
      isSelect
    )
  }
}
customElements.define('hxz-product-card', HXZProductCard)

class EngraveButton extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    ReactLoader.loadResource(this.show.bind(this))
  }
  show() {
    this.style.display = 'block'
  }
}
customElements.define('hxz-engrave-btn', EngraveButton)

class HXZCardBanner extends HTMLElement {
  constructor() {
    super()
    this.rootEl = this
  }

  connectedCallback() {
    let timeRemain = 0

    const countEl = document.querySelector(
      'hxz-cart-banner .hxz-cart-countdown-time'
    )
    if (!countEl) return
    const dataStr = this.dataset.time
    var targetDate = 0
    if (dataStr) {
      let times = dataStr.split('.').map(item => +item)
      // timeRemain = Math.abs(+new Date(...times) - +new Date()) / 1000
      //countDownDate = new Date(...times).getTime();
      targetDate = new Date(...times).getTime()
    }

    let countdownInterval = setInterval(() => {
      const now = new Date().getTime()
      const remainingTime = targetDate - now

      let days = Math.floor(remainingTime / (1000 * 60 * 60 * 24))
      let hours = Math.floor(
        (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      let minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((remainingTime % (1000 * 60)) / 1000)

      days = days < 10 ? `0${days}` : `${days}`
      hours = hours < 10 ? `0${hours}` : `${hours}`
      minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
      seconds = seconds < 10 ? `0${seconds}` : `${seconds}`

      countEl.innerHTML = `<span class="-font-bold hxz-cart-bold-text">${days}</span><span class="lg:-mx-2 -font-bold lg:-text-xl">:</span><span class="-font-bold hxz-cart-bold-text">${hours}</span><span class="lg:-mx-2 -font-bold lg:-text-xl">:</span><span class="-font-bold hxz-cart-bold-text ">${minutes}</span><span class="lg:-mx-2 -font-bold lg:-text-xl">:</span><span class="-font-bold hxz-cart-bold-text ">${seconds}</span>`

      if (remainingTime <= 0) {
        clearInterval(countdownInterval)
      }
    }, 1000)
  }

  countdown() {}
}

customElements.define('hxz-cart-banner', HXZCardBanner)

class HXZSideDrawer extends HTMLElement {
  constructor() {
    super()
    this.querySelectorAll('.collapsible-btn-icon').forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault()
        this.toggleHeight(button)
      })
    })

    this.querySelectorAll('.tab').forEach(tab => {
      const index = [...tab.parentElement.children].indexOf(tab)
      tab.addEventListener('click', () => {
        this.querySelectorAll('.sidebar-menu').forEach(el => {
          el.style.display = 'none'
        })
        tab.classList.add('active')
        this.querySelectorAll('.sidebar-menu')[index].style.display = 'block'
      })
    })
  }

  toggleHeight(el) {
    const targetBtn = el
    const targetParent = targetBtn.parentNode
    const targetGrandparent = targetParent.parentNode
    const expanded = targetParent.getAttribute('aria-expanded')

    const svg = targetBtn.querySelector('.hxz-menu-plusicon')
    svg.classList.toggle('minus')
    if (expanded === 'true') {
      // location.href = targetBtn.dataset.link
      targetParent.setAttribute('aria-expanded', 'false')
      targetGrandparent.nextElementSibling.style.height = 0
      targetGrandparent.nextElementSibling.style.visibility = 'hidden'
    } else {
      targetParent.setAttribute('aria-expanded', 'true')
      targetGrandparent.nextElementSibling.style.height = 'auto'
      targetGrandparent.nextElementSibling.style.visibility = 'visible'
    }
  }
}

customElements.define('hxz-sidebar-drawer', HXZSideDrawer)

/**
 * 闪电标识是否存在的组件
 */
class HXZLightning extends EventBusHTMLElement {
  constructor() {
    super()
    this.productId = this.getAttribute('data-product-id') || ''
    this.sku = this.getAttribute('default-sku')
    this.productInfo = this.hasAttribute('data-product-info')
    const shadow = this.attachShadow({ mode: 'open' })
    this.container = document.createElement('div')
    this.container.innerHTML = `
      <slot></slot>
    `
    shadow.appendChild(this.container)
  }
  connectedCallback() {
    // 产品详情页展示
    if (this.productInfo) {
      this.eventBind()
    } else {
      const observer = new IntersectionObserver((entries, observer) => {
        // 当目标元素进入视口时，打印 1
        if (entries[0].isIntersecting) {
          this.watchSku()
          // 停止观察目标元素
          observer.unobserve(this.parentNode)
        }
      })
      // 开始观察目标元素
      observer.observe(this.parentNode)
    }
  }
  eventBind() {
    this.eventOn(
      window.hxzEventMap.variantSelectChange(this.productId),
      value => {
        if (value && value.variants && value.variants.length == 1) {
          this.query(value.variants[0].sku)
        }
      }
    )
    setTimeout(() => {
      let value = this.eventReduce(
        window.hxzEventMap.variantSelectGet(this.productId),
        {}
      )
      if (value.variants && value.variants.length == 1) {
        this.query(value.variants[0].sku)
      }
    }, 0)
  }
  watchSku() {
    const radio = document.querySelector('hxz-variant-radios')
    if (!radio) {
      this.sku && this.query(this.sku)
      return
    }
    const initId = radio.getSelectedSku()
    this.query(initId)
    const fieldButtons = radio.querySelectorAll('fieldset label')
    fieldButtons.forEach(item => {
      item.addEventListener('click', () => {
        setTimeout(() => {
          const skuId = radio.getSelectedSku()
          this.query(skuId)
        }, 0)
      })
    })
  }
  query(id) {
    this.style.display = 'none'
    fetch(
      `https://cloud.florasis.com/lts/api/v1/customer/belong/sku/inventory?sku=${id}${
        window.USERID ? `&userId=${window.USERID}` : ''
      }`,
      {
        method: 'GET',
        headers: {
          station: 'us',
          'User-Language': window._LANGUAGE_ || 'EN',
        },
      }
    )
      .then(res => res.json())
      .then(res => {
        if (res.code == 200 && res.data) {
          this.style.display = 'block'
        } else {
          this.style.display = 'none'
        }
      })
  }
  static get observedAttributes() {
    return ['default-sku']
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'default-sku' && oldValue != null) {
      this.sku = newValue
      this.watchSku()
    }
  }
}
customElements.define('hxz-lightning', HXZLightning)

class ActiveCountDown extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.timeEnd = this.getAttribute('time-end')
    this.timeStart = this.getAttribute('time-start')
    if (!this.timeEnd) {
      this.style.display = 'none'
      return
    }
    const leaveTime = this.getTimeOffset(this.timeEnd)
    if (leaveTime <= 0) {
      this.style.display = 'none'
      return
    }
    const startTime = this.getTimeOffset(this.timeStart)
    if (startTime > 0) {
      this.style.display = 'none'
    }
    this.countDown(leaveTime, startTime)
  }
  getTimeOffset(time) {
    let nowDate = new Date().getTime()
    const offset_GMT = new Date().getTimezoneOffset()
    let GMT = nowDate + offset_GMT * 60 * 1000
    // 转化为北京时间
    let beijingTimeStamp = new Date(GMT + 8 * 60 * 60 * 1000).getTime()
    const endTime = new Date(time).getTime()
    return endTime - beijingTimeStamp
  }
  countDown(timeStamp, startTime) {
    const day = this.querySelector('.day-text')
    const hour = this.querySelector('.hour-text')
    const minute = this.querySelector('.minute-text')
    const second = this.querySelector('.second-text')
    let flag = startTime > 0 ? false : true
    const countDown = () => {
      if (startTime > 0) {
        timeStamp -= 1000
        startTime -= 1000
        setTimeout(() => {
          countDown()
        }, 1000)
        return
      }
      if (!flag) {
        this.style.display = 'block'
        flag = true
      }
      let leaveTime = timeStamp
      let days = Math.floor(leaveTime / (1000 * 60 * 60 * 24))
      let hours = Math.floor(
        (leaveTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      let minutes = Math.floor((leaveTime % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((leaveTime % (1000 * 60)) / 1000)

      days = days < 10 ? `0${days}` : `${days}`
      hours = hours < 10 ? `0${hours}` : `${hours}`
      minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
      seconds = seconds < 10 ? `0${seconds}` : `${seconds}`

      day.innerHTML = days
      hour.innerHTML = hours
      minute.innerHTML = minutes
      second.innerHTML = seconds
      timeStamp -= 1000
      if (timeStamp > 0) {
        setTimeout(() => {
          countDown()
        }, 1000)
      } else {
        this.style.display = 'none'
      }
    }
    countDown()
  }
}

customElements.define('active-count-down', ActiveCountDown)

class HXZSideDrawerJP extends HTMLElement {
  constructor() {
    super()
    this.querySelectorAll('.collapsible-btn-icon').forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault()
        this.toggleHeight(button)
      })
    })

    this.querySelectorAll('.tab').forEach(tab => {
      const index = [...tab.parentElement.children].indexOf(tab)
      tab.addEventListener('click', () => {
        this.querySelectorAll('.sidebar-menu').forEach(el => {
          el.style.display = 'none'
        })
        tab.classList.add('active')
        this.querySelectorAll('.sidebar-menu')[index].style.display = 'block'
      })
    })
  }

  toggleHeight(el) {
    const targetBtn = el
    const targetParent = targetBtn.parentNode
    const expanded = targetParent.getAttribute('aria-expanded')

    const svg = targetBtn.querySelector('.hxz-menu-plusicon')
    svg.classList.toggle('minus')
    if (expanded === 'true') {
      // location.href = targetBtn.dataset.link
      targetParent.setAttribute('aria-expanded', 'false')
      targetParent.nextElementSibling.style.height = 0
      targetParent.nextElementSibling.style.visibility = 'hidden'
    } else {
      targetParent.setAttribute('aria-expanded', 'true')
      targetParent.nextElementSibling.style.height = 'auto'
      targetParent.nextElementSibling.style.visibility = 'visible'
    }
  }
}

customElements.define('hxz-sidebar-drawer-jp', HXZSideDrawerJP)

class HxzCustomRating extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    let target = this.closest('hxz-product-card')
    if (!target) target = this.parentNode
    // 监听元素进入视口
    const observer = new IntersectionObserver((entries, observer) => {
      // 当目标元素进入视口时，打印 1
      if (entries[0].isIntersecting) {
        this.getRating()
        // 停止观察目标元素
        observer.unobserve(target)
      }
    })
    // 开始观察目标元素
    observer.observe(target)
  }
  getRating() {
    const productId = this.getAttribute('product-id')
    if (!productId) return
    fetch(`/a/choogo/lts/api/v1/review/starCount/${productId}`, {
      method: 'GET',
      headers: {
        station: 'test',
        'User-Language': window._LANGUAGE_ || 'EN',
      },
    })
      .then(res => res.json())
      .then(res => {
        if (res.code == 200 && res.data) {
          this.generateRate(res.data.star)
        }
      })
  }
  generateRate(rate) {
    if (rate == 0) return
    let fullRate = Math.floor(rate)
    const ln = rate - fullRate
    let halfRate = 0
    if (ln >= 0.3 && ln <= 0.7) {
      halfRate = 0.5
    } else if (ln > 0.7) {
      halfRate = 1
    }
    if (halfRate == 1) fullRate++
    let str = ''
    for (let i = 1; i <= 5; i++) {
      if (i <= fullRate) {
        str += this.makeStar('full')
      } else if (i == fullRate + 1 && halfRate == 0.5) {
        str += this.makeStar('half')
      } else {
        str += this.makeStar('empty')
      }
    }
    str = `<div class="rating-badge__stars">
      ${str}
    </div>`
    str += `<span class="-text-12">(${Number(rate).toFixed(1)})</span>`

    const a = document.createElement('a')
    a.href = this.getAttribute('href')
    a.className = '-mt-0 rating-badge'
    a.innerHTML = str
    this.appendChild(a)
    return str
  }
  makeStar(type) {
    if (type == 'full') {
      return `
      <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating" viewBox="0 0 12 11">
        <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill="#003b4a"/>
      </svg>
      `
    }
    if (type == 'half') {
      return `
      <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating" viewBox="0 0 12 11">
        <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Z" fill="#003b4a"/>
        <path d="M6 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill-opacity="0.4" fill="#003b4a"/>
      </svg>
      `
    }
    return `
    <svg aria-hidden="true" focusable="false" width="12" class="icon icon-star-rating" viewBox="0 0 12 11">
      <path d="M6 0v8.635L2.292 11 3.48 6.87 0 4.202l4.443-.187L6 0Zm0 0v8.635L9.708 11 8.52 6.87 12 4.202l-4.443-.187L6 0Z" fill-opacity="0.4" fill="#003b4a"/>
    </svg>
    `
  }
}

customElements.define('hxz-custom-rating', HxzCustomRating)

/**
 * 保留2位小数的四舍五入
 * @param {number} num 四舍五入的数字
 * @returns
 */
function roundToTwo(num) {
  return +(Math.round(num + 'e+2') + 'e-2')
}
/**
 *
 * @param {number} money 输入的金钱(初始币种，美元｜日元)
 * @returns 当前币种的真实价格
 */
function getCurrentPrice(money) {
  return roundToTwo(money * Shopify.currency.rate)
}
let hxzCartGiftInstance = null
class HxzCartGift extends HTMLElement {
  constructor() {
    super()
    this.currentPrice = this.getAttribute('current-price') || 0
    this.img = ''
    this.tip = ''
    this.step = 0
    this.giftMap = null
    this.mounted = false
  }
  connectedCallback() {
    hxzCartGiftInstance = this
    this.init()
    this.bindBtn()
    this.mounted = true
  }
  disconnectedCallback() {
    hxzCartGiftInstance = null
  }
  bindBtn() {
    let btns = this.querySelectorAll('.btn')
    btns.forEach(item => {
      item.addEventListener('click', () => {
        this.addEvent()
      })
    })
  }
  addEvent() {
    const targets = this.giftMap.filter(
      item => this.currentPrice >= item.threshold
    )
    if (targets.length == 0) return
    const index = targets.length - 1
    const target = this.giftMap[index]
    this.showBtnLoading(true)
    cartChangeBefore({ key: target.variantId, quantity: 1 }, 'add').then(() => {
      this.showBtnLoading(false)
    })
  }
  showBtnLoading(flag) {
    let loadingMasks = this.querySelectorAll('.loading-mask')
    if (flag) {
      loadingMasks.forEach(item => {
        item.style.display = 'flex'
      })
    } else {
      loadingMasks.forEach(item => {
        item.style.display = 'none'
      })
    }
  }
  init() {
    // 绑定数据
    let map = this.handleMap()
    if (!map) return
    this.giftMap = map
    const steps = this.giftMap.filter(
      item => this.currentPrice >= item.threshold
    )
    // 加入校验
    this.addListen()
    this.changeImg(steps.length)
    this.changeProgress(steps.length)
    this.changeBtn(steps.length)
    this.changeTip(steps.length)
    this.showPrice()
  }
  showPrice() {
    if (!this.giftMap) return
    let price = this.giftMap[this.giftMap.length - 1].lowercase
    let cent = 100
    let priceBox = this.querySelector('.gift-price')
    if (priceBox) {
      let text = getCurrentPrice(price / cent) + window.Shopify.currency.active
      priceBox.innerHTML = text
    }
  }
  addListen() {
    if (!this.giftMap || this.mounted) return
    const gifts = this.giftMap.map(item => ({
      variantId: item.variantId,
      lowercase: item.lowercase,
      excludeBundle: true,
      limit: 1,
    }))
    hxzCartHandle.addLimit(gifts, 'bg-gift')
    hxzCartHandle.addReflect(
      gifts.map(item => item.variantId),
      'bg-gift'
    )
  }
  handleMap() {
    let threshold = this.dataset.threshold
    let productIds = this.dataset.productIds
    let variantIds = this.dataset.variantIds
    let imgs = this.dataset.imgs
    if (!threshold || !productIds || !variantIds || !imgs) {
      // 隐藏当前组件
      this.style.display = 'none'
      return null
    }
    let thresholdArray = threshold.split(',')
    let productIdArray = productIds.split(',')
    let variantIdArray = variantIds.split(',')
    let imgArray = imgs.split(',')
    if (
      thresholdArray.length != productIdArray.length ||
      thresholdArray.length != variantIdArray.length ||
      thresholdArray.length != imgArray.length
    ) {
      // 隐藏当前组件
      this.style.display = 'none'
      return null
    }
    let map = []
    for (let i = 0; i < thresholdArray.length; i++) {
      let item = thresholdArray[i]
      let price = Number(item)
      if (isNaN(price)) {
        this.style.display = 'none'
        return null
      }
      map.push({
        lowercase: item * 100,
        threshold: getCurrentPrice(Number(item) * 100),
        productId: productIdArray[i],
        variantId: variantIdArray[i],
        img: imgArray[i],
      })
    }
    return map
  }
  changeImg(index) {
    let target = this.giftMap[index] || this.giftMap[this.giftMap.length - 1]
    let box = this.querySelector('.gift-img')
    if (box) {
      box.src = target.img
    }
  }
  changeTip(index) {
    let tip = this.querySelector('.gift-tip')
    let leavePrice = 0,
      cent = window._SITE_ == 'en' ? 100 : 100
    let max = this.giftMap.length
    if (index == 0) {
      leavePrice = roundToTwo(
        (this.giftMap[0].threshold - this.currentPrice) / cent
      )
      if (window._LANGUAGE_ == 'en') {
        tip.innerHTML = `Just ${leavePrice} ${Shopify.currency.active} you qualify for complimentary gifts!`
      }
      if (window._LANGUAGE_ == 'fr') {
        tip.innerHTML = `Il vous reste ${leavePrice} ${Shopify.currency.active} pour obtenir des cadeaux gratuits !`
      }
      if (window._LANGUAGE_ == 'ja') {
        tip.innerHTML = `無料特典まであと ${leavePrice} 円`
      }
    } else if (index >= max) {
      if (window._LANGUAGE_ == 'en') {
        tip.innerHTML = `Congratulations on your complimentary gift!`
      }
      if (window._LANGUAGE_ == 'fr') {
        tip.innerHTML = `Félicitations pour votre cadeau offert !`
      }
      if (window._LANGUAGE_ == 'ja') {
        tip.innerHTML = `おめでとうございます。カートに入れましょう。`
      }
    } else {
      leavePrice = roundToTwo(
        (this.giftMap[index].threshold - this.currentPrice) / cent
      )
      if (window._LANGUAGE_ == 'en') {
        tip.innerHTML = `You're just ${leavePrice} ${Shopify.currency.active} away from a gift upgrade.`
      }
      if (window._LANGUAGE_ == 'fr') {
        tip.innerHTML = `Plus que ${leavePrice} ${Shopify.currency.active} pour un meilleur cadeau.`
      }
      if (window._LANGUAGE_ == 'ja') {
        tip.innerHTML = `カートに入れました。豪華特典まであと ${leavePrice} 円`
      }
    }
  }
  changeProgress(index) {
    const progress = this.querySelectorAll('.gift-progress')
    let price = this.currentPrice
    for (let i = 0; i < progress.length; i++) {
      if (i < index) {
        progress[i].style.backgroundColor = '#003b4a'
      } else if (i == index) {
        let stepPrice = price,
          threshold = this.giftMap[i].threshold
        if (i > 0) {
          stepPrice = price - this.giftMap[i - 1].threshold
          threshold = this.giftMap[i].threshold - this.giftMap[i - 1].threshold
        }
        const percent = (stepPrice / threshold) * 100
        progress[i].style.backgroundImage =
          'linear-gradient(to right, #003b4a 0%, #003b4a ' +
          percent +
          '%, #fff ' +
          percent +
          '%, #fff 100%)'
      } else {
        progress[i].style.backgroundColor = '#fff'
      }
    }
  }
  changeBtn(index) {
    if (index == 0) {
      this.disableBtn(true)
      return
    }
    let target = this.giftMap[index - 1]
    if (this.allProducts.includes(String(target.variantId))) {
      this.disableBtn(true)
    } else {
      this.disableBtn(false)
    }
  }
  disableBtn(flag) {
    const linkBtn = this.querySelector('.link-btn.btn')
    const buttonBtn = this.querySelector('button.btn')
    if (flag) {
      linkBtn?.classList.add('-hidden')
      buttonBtn?.setAttribute('disabled', 'true')
    } else {
      linkBtn?.classList.remove('-hidden')
      buttonBtn?.removeAttribute('disabled')
    }
  }
  static get observedAttributes() {
    return ['current-products', 'current-price']
  }
  attributeChangedCallback(name, oldValue, newValue) {
    let refresh = false
    if (name === 'current-products') {
      if (!newValue) {
        this.allProducts = []
        return
      }
      this.allProducts = newValue.split(',')
      refresh = true
    }
    if (name === 'current-price') {
      this.currentPrice = newValue || 0
      refresh = true
    }
    if (this.mounted && refresh) {
      this.init()
    }
  }
}
customElements.define('hxz-bl-gift', HxzCartGift)

// 国家与语言切换
class HxzCountryLang extends HTMLElement {
  /** @type {ShadowRoot} */
  root = null

  /** @typedef {{content: HTMLSlotElement, selector: HTMLSlotElement}} Slots */
  /** @type {Slots} */
  slots = {}

  /** @type {HTMLElement} */
  langBox = null

  /** @type {HTMLElement} */
  countryBox = null

  /** @type {HTMLElement} */
  currentCountry = null

  /** @type {HTMLElement} */
  dialog = null

  /** @type {HTMLFormElement} */
  form = null

  /** @type {HTMLButtonElement} */
  submitBtn = null

  /** @type {HTMLButtonElement} */
  backBtn = null

  /** @type {HTMLButtonElement} */
  closeBtn = null

  /** @type {HTMLButtonElement} */
  selectorPage = null

  constructor() {
    super()
    const root = (this.root = this.attachShadow({ mode: 'open' }))

    // 默认展示
    {
      const slot = document.createElement('slot')
      slot.name = 'content'
      root.appendChild(slot)
    }

    // 选择页
    {
      const slot = document.createElement('slot')
      slot.name = 'selector'
      root.appendChild(slot)
    }

    // 表单
    {
      const slot = document.createElement('slot')
      slot.name = 'form'
      root.appendChild(slot)
    }
  }

  /** @param {Event} e  */
  onClick = e => {
    if (e.target.closest('[slot=content]')) {
      // 显示选择页
      this.selectorPage.classList.remove('-hidden')

      // 隐藏 part=header 部分，如果存在的话
      const h = document
        .querySelector('header-sidebar.drawer')
        ?.shadowRoot?.querySelector('[part=header]')
      if (h) h.style.setProperty('--hidden', 'none')
    } else if (e.target.dataset.name === 'lang-item') {
      /** @type {HTMLElement[]} */
      const children = e.target.parentElement.children

      // 移除所有选中效果
      for (let i = 0; i < children.length; i++) {
        const c = children[i]
        if (c === e.target) {
          children[i].classList.add('-text-[#f4d19e]', '-bg-[#003b4a]')
          children[i].classList.remove('-text-[#003b4a]', '-bg-[#f3f3f3]')
        } else {
          children[i].classList.remove('-text-[#f4d19e]', '-bg-[#003b4a]')
          children[i].classList.add('-text-[#003b4a]', '-bg-[#f3f3f3]')
        }
      }

      // 设置form
      this.form.querySelector('[name=language_code]').value =
        e.target.dataset.code
    } else if (e.target.dataset.name === 'country-item') {
      // 如果是Japan
      if (e.target.dataset.code === 'JP') {
        return this.dialog.classList.remove('-hidden')
      }
      this.currentCountry.textContent = e.target.textContent
      this.form.querySelector('[name=country_code]').value =
        e.target.dataset.code
      // 高亮
      {
        /** @type {HTMLCollection} */
        const children = this.countryBox.children

        for (let i = 0; i < children.length; i++) {
          children[i].classList.remove('-font-bold', '-bg-[#f3f3f3]')
        }

        e.target.classList.add('-font-bold', '-bg-[#f3f3f3]')
      }
    } else if (e.target.dataset.name === 'submit') {
      this.form.submit()
    } else if (e.target.dataset.name === 'cancel') {
      this.dialog.classList.add('-hidden')
    } else if (e.target.dataset.name === 'enter') {
      location.href = e.target.dataset.url
    } else if (e.target.closest('[name=back]')) {
      this.selectorPage.classList.add('-hidden')
      // 显示 part=header 部分，如果存在的话
      const h = document
        .querySelector('header-sidebar.drawer')
        ?.shadowRoot?.querySelector('[part=header]')
      if (h) h.style.removeProperty('--hidden')
    } else if (e.target.closest('[name=close]')) {
      e.target.dispatchEvent(
        new CustomEvent('dialog:force-close', {
          bubbles: true,
          cancelable: true,
          composed: true,
        })
      )
    }
  }

  connectedCallback() {
    /** @type {HTMLSlotElement} */
    const s = (this.slots.selector = this.root.querySelector('[name=selector]'))

    {
      /** @type {HTMLElement} */
      const page = (this.selectorPage = s.assignedElements()[0])

      this.langBox = page.querySelector('[name=lang-box]')
      this.langBox.addEventListener('click', this.onClick)

      this.countryBox = page.querySelector('[name=country-box]')
      this.countryBox.addEventListener('click', this.onClick)
      this.currentCountry = page.querySelector('[name=current-country]')

      this.submitBtn = page.querySelector('[name=submit]')
      this.submitBtn.addEventListener('click', this.onClick)

      this.dialog = page.querySelector('[name=dialog]')
      this.dialog.addEventListener('click', this.onClick)

      this.backBtn = page.querySelector('[name=back]')
      this.backBtn.addEventListener('click', this.onClick)

      this.closeBtn = page.querySelector('[name=close]')
      this.closeBtn.addEventListener('click', this.onClick)
    }

    {
      /** @type {HTMLSlotElement} */
      const c = (this.slots.content = this.root.querySelector('[name=content]'))
      c.addEventListener('click', this.onClick)
    }

    {
      /** @type {HTMLSlotElement} */
      const c = this.root.querySelector('[name=form]')
      this.form = c.assignedElements()[0].querySelector('form')
    }
  }

  disconnectedCallback() {
    this.slots.content.removeEventListener('click', this.onClick)
    this.countryBox.removeEventListener('click', this.onClick)
    this.langBox.removeEventListener('click', this.onClick)
    this.submitBtn.removeEventListener('click', this.onClick)
    this.dialog.removeEventListener('click', this.onClick)
    this.backBtn.removeEventListener('click', this.onClick)
    this.closeBtn.removeEventListener('click', this.onClick)
  }
}

customElements.define('hxz-country-lang', HxzCountryLang)

// 国家与语言切换(宽屏版)
class HxzCountryLangW extends HTMLElement {
  /** @type {HTMLFormElement} */
  form = null

  /** @type {HTMLElement} */
  langBox = null

  /** @type {HTMLElement} */
  countryBox = null

  /** @type {HTMLButtonElement} */
  submitBtn = null

  /** @type {HTMLButtonElement} */
  cancelBtn = null

  /** @type {HTMLElement} */
  dialog = null

  constructor() {
    super()
    const root = (this.root = this.attachShadow({ mode: 'open' }))

    // 选择面板
    {
      const slot = document.createElement('slot')
      slot.name = 'panel'
      root.appendChild(slot)
    }

    // 表单
    {
      const slot = document.createElement('slot')
      slot.name = 'form'
      root.appendChild(slot)
    }
  }

  /** @param {Event} e  */
  onClick = e => {
    if (e.target.dataset.name === 'cancel') {
      document.querySelector('hxz-country-lang-w').classList.add('-hidden')
    } else if (e.target.dataset.name === 'lang-item') {
      /** @type {HTMLElement[]} */
      const children = e.target.parentElement.children

      // 移除所有选中效果
      for (let i = 0; i < children.length; i++) {
        const c = children[i]
        if (c === e.target) {
          children[i].classList.add('-underline')
        } else {
          children[i].classList.remove('-underline')
        }
      }

      // 设置form
      this.form.querySelector('[name=language_code]').value =
        e.target.dataset.code
    } else if (e.target.dataset.name === 'country-item') {
      // 如果是Japan
      if (e.target.dataset.code === 'JP') {
        return this.dialog.classList.remove('-hidden')
      }

      this.form.querySelector('[name=country_code]').value =
        e.target.dataset.code

      // 高亮
      {
        /** @type {HTMLCollection} */
        const children = this.countryBox.children

        for (let i = 0; i < children.length; i++) {
          children[i].classList.remove('-underline')
        }

        e.target.classList.add('-underline')
      }
    } else if (e.target.dataset.name === 'submit') {
      this.form.submit()
    } else if (e.target.dataset.name === 'dialog:cancel') {
      this.dialog.classList.add('-hidden')
    } else if (e.target.dataset.name === 'enter') {
      location.href = e.target.dataset.url
    }
  }

  connectedCallback() {
    /** @type {HTMLSlotElement} */
    const s = this.root.querySelector('[name=panel]')

    /** @type {HTMLElement} */
    const page = s.assignedElements()[0]

    this.langBox = page.querySelector('[name=lang-box]')
    this.langBox.addEventListener('click', this.onClick)

    this.countryBox = page.querySelector('[name=country-box]')
    this.countryBox.addEventListener('click', this.onClick)

    this.cancelBtn = page.querySelector('[name=cancel]')
    this.cancelBtn.addEventListener('click', this.onClick)

    this.submitBtn = page.querySelector('[name=submit]')
    this.submitBtn.addEventListener('click', this.onClick)

    this.dialog = page.querySelector('[name=dialog]')
    this.dialog.addEventListener('click', this.onClick)

    {
      /** @type {HTMLSlotElement} */
      const c = this.root.querySelector('[name=form]')
      this.form = c.assignedElements()[0].querySelector('form')
    }
  }

  disconnectedCallback() {
    this.langBox.removeEventListener('click', this.onClick)
    this.countryBox.removeEventListener('click', this.onClick)
    this.cancelBtn.removeEventListener('click', this.onClick)
    this.submitBtn.removeEventListener('click', this.onClick)
    this.dialog.removeEventListener('click', this.onClick)
  }
}

customElements.define('hxz-country-lang-w', HxzCountryLangW)

class HxzYMK {
  constructor() {
    this.opened = false
    this.eventMap = new Map()
  }
  resize(width, height) {
    this.width = width > 600 ? 600 : width
    this.height = height > 900 ? 900 : height
  }
  open(skuId, target) {
    if (this.opened) return
    this.skuId = skuId || this.skuId
    this.target = target || this.target
    if (!window.YMK) {
      this.initYMK()
    } else {
      YMK.init({
        width: this.width,
        height: this.height,
      })
      YMK.open()
    }
  }
  close() {
    if (this.opened) {
      YMK.close()
    }
  }
  initYMK() {
    window.ymkAsyncInit = () => {
      YMK.init({
        width: this.width,
        height: this.height,
      })
    }
    loadScript(
      'https://plugins-media.youcamapi.cn/c47582/sdk.js?apiKey=YOUR_YOUCAM_API_KEY',
      {},
      () => {
        this.bindEvents()
        this.open()
      }
    )
  }
  addEvent(target, type, callback) {
    if (!this.eventMap.has(target)) {
      this.eventMap.set(target, new Map())
    }
    const map = this.eventMap.get(target)
    if (!map.has(type)) {
      map.set(type, [])
    }
    map.get(type).push(callback)
  }
  bindEvents() {
    YMK.addEventListener('opened', () => {
      this.opened = true
      this.emitEvent('opened')
    })
    YMK.addEventListener('loaded', () => {
      this.changeSkuId(this.skuId)
      this.emitEvent('loaded')
    })
    YMK.addEventListener('closed', () => {
      this.opened = false
      this.emitEvent('closed')
    })
    YMK.addEventListener('reset', () => {
      this.emitEvent('reset')
    })
    YMK.addEventListener('engineClosed', () => {
      this.emitEvent('engineClosed')
    })
  }
  // event: opened, loaded, closed
  emitEvent(type) {
    if (!this.eventMap.has(this.target)) return
    const map = this.eventMap.get(this.target)
    if (!map.has(type)) return
    const callbacks = map.get(type)
    callbacks.forEach(callback => {
      callback()
    })
  }
  changeSkuId(skuId, index = 1) {
    if (skuId && this.opened) {
      this.skuId = skuId
      YMK.applyMakeupBySku(this.skuId, index - 1)
    }
  }
}
const hxzYMK = new HxzYMK()

// 虚拟试妆
class HxzVirtualMakeup extends HTMLElement {
  constructor() {
    super()
    this.created = false
    this.currentSkuId = ''
    this.opened = false
    this.loaded = false
    this.singleType = false
    this.currentType = 1 // 妆容类型数量
    this.currentTypeNumber = 1 // 当前妆容类型
    this.buttonArea = null
    this.modalActionArea = {
      el: null,
      height: 264,
      skuHeight: 48,
    }
    this.skuList = []
    this.singleInfo = {
      price: '',
      variantId: '',
      familyPrice: '',
    }
    this.productName = ''
  }
  connectedCallback() {
    this.init()
    this.created = true
  }
  init() {
    let initSkuId = this.dataset.singleSkuId || ''
    this.productName = this.dataset.productName || ''
    if (initSkuId) {
      this.info = {
        type: 1,
        productId: this.dataset.productId,
        variantId: this.dataset.variantId,
        lookIndex: 0,
        list: [
          {
            hasVirtual: true,
            skuId: this.dataset.singleSkuId,
            virtualNumber: Number(this.dataset.singleType),
            name: this.productName,
            skuColor: '',
            skuImage: '',
            skuName: '',
            price: this.dataset.variantPrice,
            familyPrice: this.dataset.familyPrice || '',
            available: true,
            variantId: this.dataset.variantId,
          },
        ],
      }
      // window.hxzEventBus.emit(window.hxzEventMap.virtualVisibleOpen,info)
      // let initType = this.dataset.singleType || 1
      // this.singleType = true
      // this.currentSkuId = initSkuId
      // this.currentType = Number(initType)
      // this.singleInfo = {
      //   price: this.dataset.variantPrice || '',
      //   variantId: this.dataset.variantId || '',
      //   familyPrice: this.dataset.familyPrice || '',
      // }
    }
    if (!initSkuId) {
      let sku = this.getSkuId() || null
      this.skuList = this.getSkuList() || []
      let list = this.skuList.map(item => {
        return {
          ...item,
          virtualNumber: item.type || 1,
          name: this.productName,
          skuName: item.name,
        }
      })
      this.info = {
        type: 2,
        productId: this.dataset.productId,
        variantId: sku.variantId,
        lookIndex: 0,
        list: [...list],
      }
      // window.hxzEventBus.emit(window.hxzEventMap.virtualVisibleOpen,info)
      // if (sku && sku.skuId) {
      //   this.currentSkuId = sku.skuId
      //   this.currentType = sku.type || 1
      // } else {
      //   this.currentSkuId = null
      // }
      this.toggleEntry(sku.hasVirtual)
    }
    this.bindEvents()
    // 判断打开的容器类型 modal 和 element
    this.type = this.getAttribute('type') || 'element'
  }
  // 获取当前sku skuId
  getSkuId() {
    const sku = document.querySelector('hxz-variant-radios')
    if (!sku) return {}
    return sku.getVirtualSkuId()
  }
  /**
   * 获取当前产品的sku列表
   */
  getSkuList() {
    const sku = document.querySelector('hxz-variant-radios')
    if (!sku) return ''

    return sku.getVirtualSkuList()
  }
  bindEvents() {
    window.addEventListener('virtual:sku-change', e => {
      let data = e.detail
      this.toggleEntry(data.hasVirtual)
      let target = this.info.list.find(item => item.skuId == data.skuId)
      if (target) {
        this.info.variantId = target.variantId
      }
      // if (this.opened) {
      //   if (!data.hasVirtual) {
      //     this.virtualContainer.appendChild(
      //       showToast(
      //         window._LANGUAGE_ == 'fr'
      //           ? "Actuellement, le produit ne dispose pas d'une fonctionnalité d'essai d'ajustement."
      //           : 'Currently, the product does not have a trial fitting feature.',
      //         {
      //           success: false,
      //           shouldReturn: true,
      //         }
      //       )
      //     )
      //     return
      //   }
      //   this.currentSkuId = data.skuId
      //   this.currentTypeNumber = 1
      //   this.currentType = data.type || 1
      //   this.changeActive(this.currentSkuId)
      //   this.refreshButtons()
      // } else {
      //   this.currentSkuId = data.skuId
      //   this.currentTypeNumber = 1
      //   this.currentType = data.type || 1
      // }
    })
    this.openButton = this.querySelector('.open-btn')
    if (this.openButton) {
      this.openButton.addEventListener('click', () => {
        // this.opened = true
        // this.openYMK(
        //   this.singleType ? this.currentSkuId : this.getSkuId().skuId
        // )
        window.hxzEventBus.emit(
          window.hxzEventMap.virtualVisibleOpen,
          this.info
        )
      })
    }
  }
  toggleEntry(flag) {
    const entry = this.querySelector('.virtual-entry')
    if (entry) {
      if (flag) {
        entry.style.display = 'flex'
      } else {
        entry.style.display = 'none'
      }
    }
  }
  changeActive(skuId) {
    if (skuId) {
      hxzYMK.changeSkuId(skuId, 1)
    }
  }
  changeActiveTypeNumber(index = 1) {
    if (!this.currentSkuId) {
      return
    }
    hxzYMK.changeSkuId(this.currentSkuId, index)
  }
  bindYMK() {
    hxzYMK.addEvent(this, 'opened', () => {
      this.opened = true
      this.hideLoading(true)
      this.showContainer(true)
      if (this.type == 'modal') {
        // 展示操作区域
        document.body.style.overflow = 'hidden'
        this.renderModalActionArea()
      }
      this.renderCloseButton()
    })
    hxzYMK.addEvent(this, 'closed', () => {
      document.body.style.overflow = 'auto'
      this.opened = false
      this.loaded = false
      this.showContainer(false)
      this.currentTypeNumber = 1
    })
    hxzYMK.addEvent(this, 'loaded', () => {
      this.loaded = true
      this.currentTypeNumber = 1
      this.renderTypeButtons()
      this.removeCloseButton()
    })
    hxzYMK.addEvent(this, 'reset', () => {
      this.currentTypeNumber = 0
      this.refreshButtons()
    })
    hxzYMK.addEvent(this, 'engineClosed', () => {
      if (this.buttonArea) {
        this.buttonArea.remove()
        this.buttonArea = null
      }
      this.renderCloseButton()
    })
    this.hasBindYMK = true
  }
  openYMK(skuId) {
    if (!skuId) return
    if (!this.hasBindYMK) {
      this.bindYMK()
    }
    if (!this.virtualContainer) {
      this.virtualContainer = this.createContainer()
      let { width, height } = this.virtualContainer.getBoundingClientRect()
      if (this.type == 'modal') {
        // 保留操作区域
        let realHeight = height - this.modalActionArea.height
        if (this.skuList.length == 0) {
          realHeight += this.modalActionArea.skuHeight
        }
        hxzYMK.resize(width, realHeight)
      } else {
        hxzYMK.resize(width, height)
      }
    } else {
      // this.virtualContainer.style.display = 'block'
    }
    // this.showContainer(true)
    this.hideLoading(false)
    hxzYMK.open(skuId, this)
  }
  showContainer(flag) {
    if (!this.virtualContainer) {
      return
    }
    if (flag) {
      this.virtualContainer.classList.add('flex-important')
    } else {
      this.virtualContainer.style.display = 'none'
      this.virtualContainer.classList.remove('flex-important')
    }
  }
  createContainer() {
    if (this.virtualContainer) {
      this.virtualContainer.remove()
    }
    if (this.type == 'element') {
      const div = document.createElement('div')
      let virtual = document.createElement('div')
      virtual.id = 'YMK-module'
      virtual.className = '-w-full -h-full'
      div.appendChild(virtual)
      // div.id = 'YMK-module'
      div.className =
        '-absolute -top-0 -left-0 -right-0 -bottom-0 -z-10 -bg-gray-300 -flex-center flex-important'
      this.appendChild(div)
      return div
    } else {
      const div = document.createElement('div')
      let virtual = document.createElement('div')
      virtual.id = 'YMK-module'
      div.appendChild(virtual)
      div.className =
        '-fixed -top-0 -left-0 -right-0 -bottom-0 -bg-gray-300 -flex-center -flex-col flex-important'
      div.style.zIndex = 1000000 // 遮住聊天机器人
      const img = this.createLoadingImg()
      div.appendChild(img)
      document.body.appendChild(div)
      return div
    }
  }
  createLoadingImg() {
    const div = document.createElement('div')
    div.className =
      'virtual-loading -bg-gray-300 -w-full -h-full -absolute -flex-center -z-10 -top-0 -left-0'
    const img = document.createElement('img')
    img.src =
      'https://cdn.shopify.com/s/files/1/0528/2486/7015/files/loading.gif?v=1705290701'
    img.width = 80
    img.height = 80
    img.loading = 'eager'
    div.appendChild(img)
    return div
  }
  hideLoading(flag) {
    if (this.type == 'element') {
      const loading = this.querySelector('.virtual-loading')
      if (loading) {
        loading.style.display = flag ? 'none' : 'flex'
      }
    } else {
      const loading = this.virtualContainer.querySelector('.virtual-loading')
      if (loading) {
        loading.style.display = flag ? 'none' : 'flex'
      }
    }
  }
  refreshButtons() {
    if (!this.loaded) return
    this.renderTypeButtons()
  }
  renderTypeButtons() {
    if (
      !this.currentType ||
      isNaN(this.currentType) ||
      this.currentType < 2 ||
      !this.virtualContainer
    ) {
      return
    }
    if (this.buttonArea) {
      this.buttonArea.remove()
      this.buttonArea = null
    }
    // 渲染妆容按钮
    if (this.virtualContainer.firstChild?.firstChild) {
      let parent = this.virtualContainer.firstChild.firstChild
      parent.style.position = 'relative'
      let divEl = document.createElement('div')
      divEl.className = '-w-full -h-full -absolute -left-0 -top-0 -z-10'
      divEl.style.pointerEvents = 'none'
      divEl.innerHTML = `
          <div class="-w-full -absolute -flex-center -h-24" style="bottom:0px;left:0;" style="pointer-events: none;">
            ${this.createButtonItem()}
          </div>
        `
      let buttons = divEl.querySelectorAll('button')
      buttons.forEach((item, index) => {
        item.addEventListener('click', () => {
          this.changeTypeNumber(index + 1)
          buttons.forEach((item, index) => {
            this.toggleButtonActive(item, this.currentTypeNumber == index + 1)
          })
        })
      })
      parent.appendChild(divEl)
      this.buttonArea = divEl
    }
  }
  createButtonItem() {
    if (isNaN(this.currentType) || this.currentType < 2) return
    let str = ''
    for (let i = 1; i <= this.currentType; i++) {
      str += `<button class="-w-min -flex-auto -bg-gold -text-primary -h-24 -text-12 -leading-24 -px-16 -py-0 ${
        this.currentTypeNumber == i ? '-underline' : ''
      }" style="pointer-events: visible;">LOOK${i}</button>`
    }
    return str
  }
  toggleButtonActive(button, flag) {
    if (flag) {
      button.classList.add('-underline')
    } else {
      button.classList.remove('-underline')
    }
  }
  changeTypeNumber(index) {
    if (this.currentTypeNumber == index) {
      return
    }
    this.currentTypeNumber = index
    this.changeActiveTypeNumber(index)
  }
  renderModalActionArea() {
    if (this.modalActionArea.el) {
      this.virtualContainer.appendChild(this.modalActionArea.el)
      this.modalActionArea.el.reset(this.currentSkuId)
      return
    }

    let skuArea = document.createElement('hxz-virtual-sku-area')
    skuArea.setAttribute('data-product-name', this.productName)
    let skuList = [...this.skuList]
    if (this.singleType) {
      skuList = [
        {
          skuId: this.currentSkuId,
          price: this.singleInfo.price,
          familyPrice: this.singleInfo.familyPrice,
          variantId: this.singleInfo.variantId,
          hasVirtual: true,
          type: this.currentType,
          available: true,
          skuColor: '',
          skuImage: '',
          name: '',
        },
      ]
    }
    skuArea.setAttribute('data-sku-list', JSON.stringify(skuList))
    skuArea.setAttribute('data-current-sku-id', this.currentSkuId)
    skuArea.style.width = '100%'
    this.modalActionArea.el = skuArea
    this.virtualContainer.appendChild(skuArea)
  }
  renderCloseButton() {
    if (!this.virtualContainer || !this.opened) return
    let el = this.virtualContainer.querySelector('.virtual-close-button')
    if (el) return
    let parent = null
    if (this.type == 'modal') {
      parent = this.virtualContainer
    } else {
      parent = this.virtualContainer
    }
    let closeButton = document.createElement('button')
    closeButton.className =
      '-absolute -z-10 -right-6 -top-6 -p-0 -rounded-full -cursor-pointer -flex-center virtual-close-button'
    closeButton.style.width = '30px'
    closeButton.style.height = '30px'
    closeButton.style.backgroundColor = 'rgb(244, 209, 158)'
    closeButton.innerHTML = `
      <img alt="exit virtual try on" aria-hidden="true" src="https://app-cdn-01.perfectcorp.com/console/customer/582/47582/WebConsult/672/79b8886a-b36c-407f-85f9-a40b7619da9f.png" style="width: 100%; height: 100%;">
    `
    closeButton.addEventListener('click', () => {
      hxzYMK.close()
    })
    parent.appendChild(closeButton)
  }
  removeCloseButton() {
    if (!this.virtualContainer) return
    let closeButton = this.virtualContainer.querySelector(
      '.virtual-close-button'
    )
    if (closeButton) {
      closeButton.remove()
    }
  }
}

customElements.define('hxz-virtual-makeup', HxzVirtualMakeup)

class HxzVirtualSkuAreaOld extends HTMLElement {
  constructor() {
    super()
    this.created = false
    this.productName = ''
    this.skuList = []
    this.buttonList = []
    this.currentSku = {
      variantId: '',
      price: '',
      familyPrice: '',
      hasVirtual: false,
      type: 1,
      available: false,
      skuId: '',
      skuColor: '',
      skuImage: '',
    }
    this.currentSkuId = ''
    this.addButton = null
  }
  connectedCallback() {
    this.init()
    this.created = true
  }
  reset(skuId) {
    let index = this.skuList.findIndex(item => item.skuId == skuId)
    if (index > -1) {
      this.changeSelected(index)
    }
    this.resetQuality()
  }
  init() {
    if (this.created) return
    this.style.height = '264px'
    this.productName = this.dataset.productName || ''
    this.skuList = JSON.parse(this.dataset.skuList || [])
    this.currentSkuId = this.dataset.currentSkuId || ''
    if (!this.currentSkuId) return
    this.currentSku =
      this.skuList.find(item => item.skuId == this.currentSkuId) || {}
    let container = document.createElement('div')
    container.className = '-w-full -p-16'
    this.renderRadio(container)
    this.renderName(container)
    this.renderSkuName(container)
    this.renderQuality(container)
    this.renderButton(container)
    this.appendChild(container)
  }
  renderRadio(container) {
    if (this.skuList.length == 0 || this.skuList.length == 1) {
      this.style.height = '216px'
      return
    }
    let radio = document.createElement('div')
    radio.className =
      '-mb-10 -w-full -flex -items-center -gap-x-3 -overflow-x-auto'
    radio.style.height = '32px'
    radio.style.paddingLeft = '1px' // 防止遮住radio的outline
    this.skuList.forEach(item => {
      let sku = document.createElement('div')
      sku.style.width = '30px'
      sku.style.height = '30px'
      sku.style.position = 'relative'
      sku.style.flex = '0 0 auto'
      if (item.skuColor) {
        sku.style.backgroundColor = item.skuColor
      } else {
        sku.style.background = `url(${item.skuImage}) center / contain no-repeat`
      }
      if (this.currentSku == item) {
        sku.style.border = '2px solid white'
        sku.style.outline = '1px solid #003B4A'
      }
      if (item.available) {
        sku.style.cursor = 'pointer'
      } else {
        sku.style.cursor = 'not-allowed'
        sku.classList.add('sku-disabled')
      }
      radio.appendChild(sku)
      this.buttonList.push(sku)
    })
    this.bindChangeEvent()
    container.appendChild(radio)
  }
  renderSkuName(container) {
    if (!this.currentSku) return
    let el = this.createSkuName()
    if (el) container.appendChild(el)
  }
  createSkuName() {
    if (!this.currentSku) return
    let skuName = document.createElement('div')
    skuName.className = '-mt-16 -flex -items-center virtual-sku-name'
    skuName.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" width="20" height="20">
      <defs>
        <clipPath id="hxz-porch-window-20">
          <path transform="scale(0.4)" d="M44.822 14.586a83.901 83.901 0 0 1 -9.6 -9.955h-0.013A13.155 13.155 0 0 0 25.245 0.001a13.15 13.15 0 0 0 -10.228 4.634A84.159 84.159 0 0 1 4.537 14.868a13.161 13.161 0 0 0 -4.536 9.884 13.154 13.154 0 0 0 4.922 10.466v0.014a84.128 84.128 0 0 1 9.382 9.533q0.382 0.505 0.805 0.968l0.011 0.013A13.163 13.163 0 0 0 24.754 50h0.137a13.151 13.151 0 0 0 10.278 -4.859 84.02 84.02 0 0 1 9.862 -9.649 13.154 13.154 0 0 0 4.968 -10.245 13.153 13.153 0 0 0 -5.176 -10.662Z" fill="rgb(0,0,0)"></path>
        </clipPath>
      </defs>
      ${
        this.currentSku.skuColor
          ? `<rect clip-path="url(#hxz-porch-window-20)" width="100%" height="100%" fill="${this.currentSku.skuColor}"></rect>`
          : `<image href="${this.currentSku.skuImage}" clip-path="url(#hxz-porch-window-20)" width='100%' height='100%'></image>`
      }
    </svg>
    <span class='-text-14 -leading-20 -text-primary -ml-8'>${
      this.currentSku.name
    }</span>
    `
    return skuName
  }
  changeSkuName() {
    let skuName = this.querySelector('.virtual-sku-name')
    if (skuName) {
      let el = this.createSkuName()
      skuName.replaceWith(el)
    }
  }
  renderName(container) {
    let name = document.createElement('div')
    name.className =
      '-w-full -text-16 -leading-20 -text-left -uppercase -text-primary -line-clamp-2'
    name.style.height = '40px'
    name.innerHTML = this.productName
    container.appendChild(name)
  }
  renderQuality(container) {
    const quality = document.createElement('div')
    quality.className = '-mt-16 -w-full -flex -items-center'
    quality.innerHTML = `
      ${
        this.currentSku.familyPrice
          ? `
      <span class='price -text-primary -text-20 -leading-24 -font-semibold -mr-8'>${
        this.currentSku.familyPrice
      }</span>
      <del class='del-price -text-14 -leading-28 -mr-8' style='color:#6B7075;display:${
        this.currentSku.familyPrice ? 'inline' : 'none'
      }'>${this.currentSku.price}</del>
      `
          : `
      <span class='price -text-primary -text-20 -leading-24 -font-semibold -mr-8'>${this.currentSku.price}</span>
      `
      }
      <div
        class='-flex -items-center -justify-between -p-8'
        style='width:88px;border:1px solid rgba(28, 31, 35, 0.28);'
      >
        <svg class='iconpark-icon -cursor-pointer quantity-minus' style='font-size: 16px'>
          <use href="#minus">1</use>
        </svg>
        <span class='-text-14 -leading-20 -text-primary quantity-num'>1</span>
        <svg class='iconpark-icon -cursor-pointer quantity-add' style='font-size: 16px'>
          <use href="#add-6bgnmb0o"></use>
        </svg>
      </div>
    `
    quality.querySelector('.quantity-minus').addEventListener('click', () => {
      let num = quality.querySelector('.quantity-num')
      let current = Number(num.innerHTML)
      if (current > 1) {
        num.innerHTML = current - 1
      }
    })
    quality.querySelector('.quantity-add').addEventListener('click', () => {
      let num = quality.querySelector('.quantity-num')
      let current = Number(num.innerHTML)
      num.innerHTML = current + 1
    })
    container.appendChild(quality)
  }
  resetQuality() {
    let num = this.querySelector('.quantity-num')
    num.innerHTML = 1
  }
  renderButton(container) {
    const button = document.createElement('button')
    let classStr = '-bg-primary -text-gold -cursor-pointer'
    if (!this.currentSku.available) {
      classStr = '-bg-gray-200 -text-primary -cursor-not-allowed'
    }
    button.className =
      '-mt-16 -h-36 -w-full -relative -text-center -text-14 -uppercase' +
      ' ' +
      classStr
    button.style.lineHeight = '36px'
    button.innerHTML =
      window._LANGUAGE_ == 'fr' ? 'Ajouter au panier' : 'add to bag'
    button.addEventListener('click', () => {
      if (!this.currentSku.available) return
      this.addToBag(button)
    })
    container.appendChild(button)
    this.addButton = button
  }
  changeButton() {
    if (this.currentSku.available) {
      this.addButton.classList.add(
        '-bg-primary',
        '-text-gold',
        '-cursor-pointer'
      )
      this.addButton.classList.remove(
        '-bg-gray-200',
        '-text-primary',
        '-cursor-not-allowed'
      )
      this.addButton.innerHTML =
        window._LANGUAGE_ == 'fr' ? 'Ajouter au panier' : 'add to bag'
    } else {
      this.addButton.classList.add(
        '-bg-gray-200',
        '-text-primary',
        '-cursor-not-allowed'
      )
      this.addButton.classList.remove(
        '-bg-primary',
        '-text-gold',
        '-cursor-pointer'
      )
      this.addButton.innerHTML =
        window._LANGUAGE_ == 'fr' ? 'En rupture' : 'sold out'
    }
  }
  bindChangeEvent() {
    this.buttonList.forEach((item, index) => {
      item.addEventListener('click', () => {
        this.changeSelected(index)
      })
    })
  }
  changeSelected(index) {
    if (this.currentSku == this.skuList[index]) return
    this.currentSku = this.skuList[index]
    this.currentSkuId = this.currentSku.skuId
    this.buttonList.forEach((item, i) => {
      if (i == index) {
        item.style.border = '2px solid white'
        item.style.outline = '1px solid #003B4A'
      } else {
        item.style.border = 'none'
        item.style.outline = 'none'
      }
    })
    this.changeButton()
    this.changePrice()
    this.changeSkuName()
    // 触发sku change
    // window.dispatchEvent(
    //   new CustomEvent('virtual:sku-change', {
    //     detail: {
    //       ...this.currentSku,
    //     },
    //   })
    // )
    // 触发详情页本身的选择器
    this.updateOriginRadio(this.currentSku.name)
  }
  updateOriginRadio(name) {
    let hxzVariantRadios = document.querySelector('hxz-variant-radios')
    if (hxzVariantRadios) {
      let radios = hxzVariantRadios.querySelectorAll('input')
      radios.forEach(item => {
        if (item.value == name) {
          item.click()
        }
      })
    }
  }
  changePrice() {
    if (this.currentSku.familyPrice) {
      let price = this.querySelector('.price')
      let delPrice = this.querySelector('.del-price')
      price.innerHTML = this.currentSku.familyPrice
      if (delPrice) {
        delPrice.style.display = 'inline'
        delPrice.innerHTML = this.currentSku.price
      }
    } else {
      let price = this.querySelector('.price')
      let delPrice = this.querySelector('.del-price')
      price.innerHTML = this.currentSku.price
      if (delPrice) {
        delPrice.style.display = 'none'
      }
    }
  }
  addToBag() {
    if (!this.currentSku.available) return
    let num = Number(this.querySelector('.quantity-num').innerHTML)
    if (isNaN(num)) return
    this.changeButtonLoading(true)
    let variantId = this.currentSku.variantId
    cartChangeBefore({ key: variantId, quantity: num }, 'add')
      .then(() => {
        this.appendChild(
          showToast(
            window._LANGUAGE_ == 'fr'
              ? 'Ajouté au panier avec succès.'
              : 'Added to cart successfully.',
            {
              success: true,
              shouldReturn: true,
            }
          )
        )
      })
      .finally(() => {
        this.changeButtonLoading(false)
      })
  }
  changeButtonLoading(flag) {
    if (flag) {
      this.addButton.classList.add('btn-loading')
    } else {
      this.addButton.classList.remove('btn-loading')
    }
  }
}

customElements.define('hxz-virtual-sku-area-old', HxzVirtualSkuAreaOld)

class HxzEngravingPrice extends HTMLElement {
  constructor() {
    super()
    this.price = 5
  }
  connectedCallback() {
    this.price = this.getAttribute('price') || 5
    this.render()
  }
  render() {
    if (!this.price) return
    let span = this.querySelector('span')
    if (!span) {
      span = document.createElement('span')
      this.appendChild(span)
    }
    let price = this.price * window.Shopify.currency.rate
    // 保留两位小数
    price = price.toFixed(2)
    span.innerHTML = `${window.Shopify.currency.active}${price}`
  }
}
customElements.define('hxz-engraving-price', HxzEngravingPrice)

class HxzQuantityButton extends EventBusHTMLElement {
  constructor() {
    super()
    this.value = 0
    this.valueEl = null
    this.disabled = false
  }
  connectedCallback() {
    let sub = this.querySelector('.sub')
    let plus = this.querySelector('.plus')
    this.isDynamic = this.hasAttribute('dynamic')
    this.productId = this.getAttribute('data-product-id')
    if (this.productId) {
      this.eventOn(
        window.hxzEventMap.productQuantityChange(this.productId),
        value => {
          if (this.value != value) {
            this.value = value
            this.valueEl.innerText = this.value
          }
        }
      )
    }
    this.valueEl = this.querySelector('.num')
    let disabled = this.hasAttribute('disabled')
    this.min = this.getAttribute('min') || 0
    this.max = this.getAttribute('max') || 999
    let initValue = Number(this.valueEl.innerText)
    if (initValue >= this.min) {
      this.value = initValue
    } else {
      this.valueEl.innerText = this.min
      this.value = this.min
    }
    setTimeout(() => {
      if (this.value != 0) {
        this.dispatchChanged()
      }
    }, 10)
    if (disabled) {
      this.style.cursor = 'not-allowed'
    } else {
      sub.addEventListener('click', this.sub.bind(this))
      plus.addEventListener('click', this.plus.bind(this))
      sub.style.cursor = 'pointer'
      plus.style.cursor = 'pointer'
    }
    // 监听展开动画
    if (this.isDynamic) {
      const toggleFn = e => {
        e.stopPropagation()
        this.classList.add('active')
        const resetWidth = event => {
          if (
            (event.type === 'click' || event.type === 'touch') &&
            event.target === this
          ) {
            return // 如果点击的是元素A本身，不执行恢复操作
          }
          this.classList.remove('active')
          this.addEventListener('click', toggleFn)

          // 移除全局点击事件监听器
          document.removeEventListener('click', resetWidth)
          // 移除滚动事件监听器
          window.removeEventListener('scroll', resetWidth)
        }
        // 添加全局点击事件监听器
        document.addEventListener('click', resetWidth)
        //
        document.addEventListener('touch', resetWidth)
        // 添加滚动事件监听器
        window.addEventListener('scroll', resetWidth)
        this.removeEventListener('click', toggleFn)
      }
      this.addEventListener('click', toggleFn)
    }
  }
  plus(e) {
    e.stopPropagation()
    if (this.value < this.max) {
      this.value++
      this.valueEl.innerText = this.value
      this.dispatchChanged()
    }
  }
  sub(e) {
    e.stopPropagation()
    if (this.value > this.min) {
      this.value--
      this.valueEl.innerText = this.value
      this.dispatchChanged()
    }
  }
  dispatchChanged() {
    this.dispatchEvent(
      new CustomEvent('quantity-change', {
        detail: this.value,
        bubbles: true,
      })
    )
    // 互相同步
    if (this.productId) {
      this.eventEmit(
        window.hxzEventMap.productQuantityChange(this.productId),
        this.value
      )
    }
  }
  getValue() {
    return this.value
  }
}
customElements.define('hxz-quantity-button', HxzQuantityButton)

/**
 * @field {string} data-init-variant 初始选中的variant，可用于判断是否可购买
 * @field {1 | 2} type 卡片类型，1:卡片展示的是具体sku，2:卡片展示的是spu
 */
class HxzSelectCard extends HTMLElement {
  constructor() {
    super()
    this.currentVariant = null
    this.productId = null
    this.type = 0
    this.quantity = 0
    this.price = ''
    this.sku = ''
    this.available = false
    this.productName = ''
    this.variantName = ''
  }
  connectedCallback() {
    let initVariant = this.getAttribute('data-init-variant')
    this.productId = this.getAttribute('data-product-id') || null
    this.currentVariant = initVariant
    this.type = this.getAttribute('type') || 0
    this.saleCard = this.hasAttribute('sale-card') // 是否是销售卡片,type必须为2
    this.sku = this.getAttribute('data-sku') || '' // sku 列表切换展示图片和试妆使用
    this.available = this.hasAttribute('data-available')
    this.price = this.getAttribute('data-init-price') || ''
    this.productName = this.getAttribute('data-product-name') || ''
    this.variantName = this.getAttribute('data-variant-name') || ''
    // 判断是否可选中，sku:当前sku售完，spu：所有sku售完
    this.eventBind()
  }
  eventBind() {
    // 抛出点击事件|数量变化事件
    if (!this.saleCard) {
      this.addEventListener('click', () => {
        this.dispatchEvent(
          new CustomEvent('select-card-click', {
            detail: this.currentVariant,
            bubbles: true,
          })
        )
      })
      this.addEventListener('quantity-change', e => {
        e.stopPropagation()
        // 向上抛
        this.dispatchEvent(
          new CustomEvent('select-card-change', {
            bubbles: true,
          })
        )
      })
    }
    if (this.type == 2) {
      // 接受下面sku更新事件
      // e.detail: {id:variantId,available:boolean,img:string,price:string}
      this.addEventListener('sku-change', e => {
        e.stopPropagation()
        this.currentVariant = e.detail.id
        this.price = e.detail.price
        this.available = e.detail.available
        this.sku = e.detail.sku
        this.variantName = e.detail.variantName
        this.changeShowImg(e.detail.img)
        if (!this.saleCard) {
          // 向上抛
          this.dispatchEvent(
            new CustomEvent('select-card-change', {
              bubbles: true,
            })
          )
        }
        let addBtn = this.querySelector('.add_button')
        if (addBtn) {
          if (this.available) {
            addBtn.classList.remove('disabled')
          } else {
            addBtn.classList.add('disabled')
          }
        }
      })
    }
    let addBtn = this.querySelector('.add_button')
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        if (addBtn.hasAttribute('need-login')) {
          window.login && window.login()
        } else {
          this.addToCart()
        }
      })
    }
    // 阻止组件内a标签的点击事件
    let link = this.querySelector('a')
    if (link) {
      link.addEventListener('click', e => {
        e.preventDefault()
        let url = link.href + '?variant=' + this.currentVariant
        window.location.href = url
      })
    }
  }
  // 更新class 为 .card-image 元素的 src
  changeShowImg(url) {
    let el = this.querySelector('.card-image')
    if (el) {
      el.setAttribute('src', url)
    }
  }
  addToCart() {
    let value = this.getValue()
    if (!value.available) return
    window.addToCart([{ id: value.variantId, quantity: value.quantity || 1 }])
  }
  getValue() {
    let quantityEl = this.querySelector('hxz-quantity-button')
    let quantity = quantityEl?.getValue() || 0
    return {
      productId: this.productId,
      variantId: this.currentVariant,
      quantity: quantity,
      available: this.available,
      price: this.price, // shopify 转换后价格 $xx USD
      sku: this.sku,
      productName: this.productName,
      variantName: this.variantName,
    }
  }
}
customElements.define('hxz-select-card', HxzSelectCard)

/**
 * 横版的产品卡片
 * data-init-variant: 初始选中的variant
 * data-product-id: 产品id
 * data-init-price: 初始价格
 * data-available: 是否可售卖
 */
class HxzSelectLineCard extends HTMLElement {
  constructor() {
    super()
    this.currentVariant = null
    this.productId = null
    this.price = ''
    this.available = false
    this.filters = []
    this.productName = ''
    this.variantName = ''
  }
  connectedCallback() {
    this.currentVariant = this.getAttribute('data-init-variant') || null
    this.productId = this.getAttribute('data-product-id') || null
    this.price = this.getAttribute('data-init-price') || ''
    this.available = this.hasAttribute('data-available')
    this.productName = this.getAttribute('data-product-name') || ''
    this.variantName = this.getAttribute('data-variant-name') || ''
    this.eventBind()
  }
  eventBind() {
    let options = this.querySelectorAll('.sku-option[data-available="true"]')
    options.forEach(option => {
      option.addEventListener('click', () => {
        this.changeActive(option)
      })
    })
    let filter = this.querySelector('.variant-filter')
    if (filter) {
      this.filters = []
      this.addEventListener('select-change', e => {
        e.stopPropagation()
        this.filterChange(e.detail)
      })
    }
  }
  changeActive(option) {
    let variantId = option.getAttribute('data-variant-id')
    if (variantId == this.currentVariant) return
    let imageEl = this.querySelector('.card-image')
    let priceEl = this.querySelector('.card-price')
    imageEl.setAttribute('src', option.getAttribute('data-img'))
    this.price = option.getAttribute('data-price')
    priceEl.innerText = this.price
    let oldOption = this.querySelector('.sku-option.active')
    if (oldOption) {
      oldOption.classList.remove('active')
    }
    option.classList.add('active')
    this.currentVariant = variantId
    this.variantName = option.getAttribute('data-variant-name')
    let variantTitle = this.querySelector('.variant-title')
    if (variantTitle) {
      variantTitle.innerText = this.variantName
    }
    this.dispatchEvent(
      new CustomEvent('select-line-card-change', {
        detail: this.getValue(),
        bubbles: true,
      })
    )
  }
  filterChange({ label, value }) {
    let target = this.filters.find(item => item.label == label)
    if (target) {
      if (target.value == value) return
      target.value = value
    } else {
      this.filters.push({ label, value })
    }
    this.changeOptions()
  }
  changeOptions() {
    let filter = this.filters.map(item => item.value).filter(v => v != 'all')
    let options = this.querySelectorAll('.sku-option')
    options.forEach(option => {
      let value = option.getAttribute('data-filter').split('||')
      let flag = filter.every(f => value.includes(f))
      if (flag) {
        option.classList.remove('-hidden')
      } else {
        option.classList.add('-hidden')
      }
    })
  }
  getValue() {
    return {
      productId: this.productId,
      variantId: this.currentVariant,
      quantity: 1,
      available: this.available,
      price: this.price, // shopify 转换后价格 $xx USD
      productName: this.productName,
      variantName: this.variantName,
    }
  }
}

customElements.define('hxz-select-line-card', HxzSelectLineCard)

// 使用 swiper 插件，定制的 bundle 模块滚动区域
// 注意：使用时需要页面中存在 swiper 的样式和脚本
class HxzBundleSwiper extends HTMLElement {
  constructor() {
    super()
    this.swiper = null
    this.currentIndex = 0
    this.options = {}
    this.paginationChange = []
  }
  connectedCallback() {
    let options = this.getAttribute('data-options') || ''
    if (options) {
      this.options = JSON.parse(options)
    }
    this.initSwiper()
  }
  initSwiper() {
    let container = this.querySelector('.swiper-shadow')
    let that = this
    this.maxLength = this.querySelectorAll('.swiper-slide').length
    this.swiper = new Swiper(container, {
      ...this.options,
      on: {
        init: function () {
          that.style.display = 'block'
          setTimeout(() => {
            that.style.opacity = 1
          }, 300)
        },
        slideChange: function (swiper) {
          that.currentIndex = this.activeIndex
          if (that.paginationChange.length > 0) {
            that.paginationChange.forEach(fn => {
              fn(swiper)
            })
          }
        },
      },
    })
    let paginationList = this.querySelectorAll('.bundle-pagination')
    if (paginationList.length > 0) {
      for (let pagination of paginationList) {
        this.bindPagination(pagination)
      }
    }
    this.paginationChange.forEach(fn => {
      fn({ isBeginning: true, isEnd: false })
    })
  }
  changeActiveIndex(activeIndex) {
    this.currentIndex = activeIndex
    this.swiper.slideTo(activeIndex)
  }

  bindPagination(el) {
    let sub = el.querySelector('.pagination-sub')
    let step = Number(el.getAttribute('data-step')) || 0
    if (sub) {
      sub.addEventListener('click', e => {
        let subIndex = this.currentIndex - step
        this.currentIndex = subIndex >= 0 ? subIndex : 0
        this.swiper.slideTo(this.currentIndex)
      })
      this.paginationChange.push(swiper => {
        if (swiper.isBeginning) {
          sub.style.opacity = '0.35'
          sub.classList.add('-cursor-not-allowed')
        } else {
          sub.style.opacity = '1'
          sub.classList.remove('-cursor-not-allowed')
        }
      })
    }
    let plus = el.querySelector('.pagination-plus')
    if (plus) {
      plus.addEventListener('click', e => {
        let plusIndex = this.currentIndex + step
        this.currentIndex =
          plusIndex <= this.maxLength - step ? plusIndex : this.maxLength - step
        this.swiper.slideTo(this.currentIndex)
      })
      this.paginationChange.push(swiper => {
        if (swiper.isEnd) {
          plus.style.opacity = '0.35'
          plus.classList.add('-cursor-not-allowed')
        } else {
          plus.style.opacity = '1'
          plus.classList.remove('-cursor-not-allowed')
        }
      })
    }

    let dots = el.querySelectorAll('.bundle-pagination-dot')
    if (dots.length > 0) {
      dots.forEach((d, i) => {
        d.addEventListener('click', () => {
          let index = i * step
          this.swiper.slideTo(index)
        })
      })
      // 双向绑定
      this.paginationChange.push(() => {
        dots.forEach((d, index) => {
          let curDot = Math.floor(this.currentIndex / step)
          let path = d.querySelector('path')
          path.style.fill = 'none'
          if (index == curDot) {
            path.style.fill = '#003b4a'
          }
        })
      })
    }
  }
}
customElements.define('hxz-bundle-swiper', HxzBundleSwiper)

/**
 * 自带弹窗的sku选择器,固定样式
 * data-options 来自内部的 script 脚本中的json
 */
class HxzVariantPicker extends EventBusHTMLElement {
  constructor() {
    super()
    this.container = null
    this.productId = null
    this.dotsEl = []
  }
  connectedCallback() {
    this.size = this.getAttribute('data-size') || 'small'
    this.productId = this.getAttribute('data-product-id') || null
    if (!this.productId) return
    this.currentVariant = this.getAttribute('data-init-variant') || null
    const json = this.querySelector(
      '.product_variant_json[type="application/json"]'
    )
    if (json) {
      this.variants = JSON.parse(json.textContent)
    }
    const options = this.querySelector(
      '.product_options_json[type="application/json"]'
    )
    if (options) {
      this.options = JSON.parse(options.textContent)
    }
    if (this.variants.length > 1 && this.currentVariant) {
      if (this.size == 'small') {
        this.renderSmall()
      }
      if (this.size == 'large') {
        this.renderLarge()
      }
    }
  }
  renderSmall() {
    let currentIndex = this.variants.findIndex(
      item => item.id == this.currentVariant
    )
    let maxStart = this.variants.length - 4
    let startIndex = Math.max(0, Math.min(currentIndex, maxStart))
    let template = this.querySelector('template[class="dot-picker"]').content
    let fragment = document.createDocumentFragment()
    let dots = []
    for (let i = startIndex; i < startIndex + 4; i++) {
      let variant = this.variants[i]
      if (variant) {
        let node = null
        if (variant.skuColor) {
          node = template.querySelector('.dot-picker-color').cloneNode(true)
          node.querySelector('.dot').style.fill = variant.skuColor
        } else {
          node = template.querySelector('.dot-picker-image').cloneNode(true)
          node.querySelector('.dot').setAttribute('href', variant.skuImage)
        }
        if (variant.available) {
          node.classList.add('-cursor-pointer')
          dots.push({ el: node, variant: variant })
        } else {
          node.classList.add('-cursor-not-allowed')
        }
        if (variant.id == this.currentVariant) {
          node.classList.add('active')
        }
        fragment.appendChild(node)
      }
    }
    this.dotsEl = dots
    dots.forEach(dot => {
      this.bindAvailableDot(dot.el, dot.variant)
    })
    if (this.variants.length > 4) {
      let moreBtn = document.createElement('div')
      moreBtn.className =
        '-flex-center -cursor-pointer -text-12 -leading-16 -font-medium -text-[#1c1f23]'
      moreBtn.innerHTML = `
        <span style="padding-right:4px;">+${this.variants.length - 4}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
          <path d="M0.667968 0.916992L4.66797 4.91699L0.667969 8.91699" stroke="#1C1F23" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `
      this.bindDrawer(moreBtn)
      fragment.appendChild(moreBtn)
    }
    let div = document.createElement('div')
    div.className = '-w-full -flex-center'
    div.appendChild(fragment)
    if (this.container) {
      this.container.remove()
    }
    this.container = div
    this.appendChild(div)
  }
  renderLarge() {}
  bindDrawer(el) {
    el.addEventListener('click', () => {
      let eventId = new Date().getTime() + this.productId
      let drawer = document.createElement('hxz-variant-picker-drawer')
      drawer.setAttribute('data-variants', JSON.stringify(this.variants))
      drawer.setAttribute('data-event-id', eventId)
      drawer.setAttribute('data-current-variant', this.currentVariant)
      if (this.options) {
        drawer.setAttribute('data-options', JSON.stringify(this.options))
      }
      this.eventOn(window.hxzEventMap.productSkuChange(eventId), variantId => {
        this.eventOff(window.hxzEventMap.productSkuChange(eventId))
        if (variantId) {
          this.changeSelect(variantId)
        }
      })
      document.body.appendChild(drawer)
    })
  }
  bindAvailableDot(el, variant) {
    el.addEventListener('click', () => {
      this.changeSelect(variant.id)
    })
  }
  bindDisableDot(el, variant) {
    // el.addEventListener('click', () => {
    //   this.changeSelect(id)
    // })
  }
  changeSelect(variantId) {
    if (this.currentVariant == variantId) return
    let target = this.variants.find(item => item.id == variantId)
    if (target) {
      this.currentVariant = variantId
      this.dispatchEvent(
        new CustomEvent('sku-change', {
          detail: {
            id: target.id,
            available: target.available,
            img: target.img,
            price: target.price,
            sku: target.sku,
            variantName: target.title,
          },
          bubbles: true,
        })
      )
      let isRender = this.dotsEl.find(d => d.variant.id == variantId)
      if (isRender) {
        this.dotsEl.forEach(d => {
          if (d.variant.id == variantId) {
            d.el.classList.add('active')
          } else {
            d.el.classList.remove('active')
          }
        })
      } else {
        if (this.size == 'small') {
          this.renderSmall()
        }
        if (this.size == 'large') {
          this.renderLarge()
        }
      }
    }
  }
}
customElements.define('hxz-variant-picker', HxzVariantPicker)

class HxzVariantPickerDrawer extends EventBusHTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    document.body.style.overflow = 'hidden'
    let variants = this.getAttribute('data-variants')
    let filterJson = this.getAttribute('data-options')
    this.currentVariant = this.getAttribute('data-current-variant')
    this.eventId = this.getAttribute('data-event-id')
    this.needAdd = this.hasAttribute('data-need-add') // 需要有加购按钮
    this.canDisable = this.hasAttribute('data-can-disable') // 可点击不可选中的项
    if (filterJson) {
      this.filters = JSON.parse(filterJson)
    }
    if (!variants || !this.currentVariant || !this.eventId) {
      this.close()
    } else {
      this.variants = JSON.parse(variants)
      this.render()
    }
  }
  disconnectedCallback() {
    document.body.style.overflow = 'auto'
  }
  render() {
    let list = ''
    this.variants.forEach(variant => {
      list += this.createWindow({
        ...variant,
        active: this.currentVariant == variant.id,
      })
    })
    let filters = ''
    if (this.filters && this.filters.length > 1) {
      filters = `
        <div class="variant-filter -w-full -pt-8 -flex -items-center -justify-start -gap-x-3">
          <span class="-text-14 -leading-16 -font-semibold">Filter</span>
          ${this.filters
            .map(filter => this.createFilterSelect(filter))
            .join('')}
        </div>
      `
    }
    let elStr = this.createContainer(list, this.variants.length, filters)
    this.innerHTML = elStr
    this.bindEvent()
  }
  createContainer(list, size, filters) {
    return `
    <div class="-fixed -top-0 -left-0 -bottom-0 -right-0 -bg-black -bg-opacity-60" style="z-index: 999;">
      <div class="-w-full -h-full -relative">
        <div class="-w-full -absolute -top-0 -bottom-0 -left-0 drawer-mask"></div>
        <div
          class="-absolute -z-10 -bottom-0 -left-0 -top-1/2 -right-0 -mdx:-left-auto -mdx:-top-0 -mdx:-w-[500px] -bg-white -flex -flex-col -items-stretch">
          <div class="-px-16 -py-12 -md:-px-32 -md:-py-16 -mdx:-px-24 -mdx:-py-24 -flex-none">
            <div class="-w-full -h-16 -flex -justify-end">
              <svg class="drawer-close -cursor-pointer" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2.66797 2.66699L13.3346 13.3337" stroke="#333333" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M2.66797 13.3337L13.3346 2.66699" stroke="#333333" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
          <div class="-flex-auto -w-full -overflow-y-auto -px-16 -md:-px-32 -mdx:-pl-48 -mdx:-pr-24">
            <p class="-text-16 -leading-22 -uppercase -font-semibold"><span style="margin-right: 8px;">${size}</span> <span>shade${
      size > 1 ? 's' : ''
    }</span></p>
            <div class="-w-full -py-16 -flex -flex-col -gap-y-3 -mdx:-gap-y-6">
              ${filters}
              ${list}
            </div>
          </div>
          ${
            this.needAdd
              ? `
          <div class="drawer-buttons -py-12 -px-16 -md:-px-32 -mdx:-px-48 -flex-none"
            style="border-top: 1px solid #E6E8EA">
            <button class="-w-full -bg-primary -text-white -leading-12 -text-16 -uppercase -text-center"
              style="height: 48px;border-radius: 100px;">
              add to bag
            </button>
          </div>
          `
              : ''
          }
        </div>
      </div>
    </div>
    `
  }
  createWindow({
    skuColor,
    skuImage,
    title,
    desc,
    available,
    active,
    id,
    options = [],
  }) {
    if (skuColor) {
      return `
      <div data-id="${id}" data-option="${options.join(
        '|'
      )}" class="-w-full -flex variant-btn -items-center -justify-between -group ${
        active ? 'active' : ''
      } ${available ? 'enable' : 'disable'} ${
        this.canDisable
          ? '-cursor-pointer'
          : available
          ? '-cursor-pointer'
          : '-cursor-not-allowed'
      }">
        <div class="-mr-8 -flex-none -relative" style="width: 56px;height: 56px;">
        <svg viewBox="0 0 56 56">
          <path d="M28.6,55.7c-2.1,0-5.2-0.5-7-1.3c-1.9-0.9-3.5-2.1-4.8-3.7l-0.4-0.4c-3.3-4-7.1-7.8-10.9-11.2l0,0  c-1.8-1.3-3.2-3.1-4.1-5.1c-0.9-2-1.5-4.2-1.4-6.4c0-2.1,0.5-4.2,1.4-6.1c0.9-1.9,2.3-3.6,3.9-4.9c4.2-3.5,8.1-7.3,11.5-11.3  c1.3-1.7,3-3,4.9-3.9c1.9-0.9,4-1.3,6.1-1.3H28h0.2c2.1,0,4.2,0.4,6.1,1.3c1.9,0.8,3.5,2.1,4.9,3.7c3.6,4.1,7.5,8,11.5,11.3  c1.7,1.3,3,3,3.9,4.9c0.9,1.9,1.4,4,1.4,6.1c0,2.2-0.5,4.4-1.4,6.4c-0.9,2-2.4,3.8-4.1,5.1h-0.1c-3.9,3.5-7.6,7.3-10.8,11.2  l-0.2,0.3c-1.3,1.5-3.1,3.1-4.9,4C32.6,55.2,30.6,55.7,28.6,55.7" fill="${skuColor}"/>
        </svg>
          <i
          class="-hidden group-[.disable]:-block"
          style="
            background: #fff;
            height: 1px;
            position: absolute;
            top: 0;
            left: 0;
            transform: rotate(-45deg) translate(-14px,22px);
            width: 75%;
          "
        ></i>
        </div>
        <div class="-flex-auto">
          <p class="-mb-2 -text-14 -leading-16 -font-semibold">${title}</p>
          <p class="-text-12 -leading-14 -break-words -line-clamp-2 -uppercase">${desc}</p>
        </div>
        <div class="-ml-8 -flex-none -opacity-0 group-[.active]:-opacity-100" style="width: 16px;height: 16px;">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M14.3327 3.6665L5.62435 12.3332L1.66602 8.39377" stroke="#333333" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      `
    } else {
      return `
      <div data-id="${id}" data-option="${options.join(
        '|'
      )}" class="variant-btn -w-full -flex -items-center -justify-between -group ${
        active ? 'active' : ''
      } ${available ? 'enable' : 'disable'} ${
        this.canDisable
          ? '-cursor-pointer'
          : available
          ? '-cursor-pointer'
          : '-cursor-not-allowed'
      }">
        <div class="-mr-8 -flex-none -relative" style="width: 56px;height: 56px;">
        <svg viewBox="0 0 56 56">
          <defs>
            <clipPath id="hxz-variant-picker-drawer">
            <path xmlns="http://www.w3.org/2000/svg" class="st0" d="M28.6,55.1c-2.1,0-5.1-0.5-6.8-1.3c-1.9-0.9-3.4-2.1-4.7-3.6l-0.4-0.4c-3.2-3.9-6.9-7.6-10.7-11l0,0  c-1.8-1.3-3.1-3-4-5s-1.5-4.1-1.4-6.3c0-2.1,0.5-4.1,1.4-6c0.9-1.9,2.3-3.5,3.8-4.8C9.9,13.4,13.7,9.7,17,5.8  C18.3,4.1,20,2.9,21.8,2s3.9-1.3,6-1.3H28h0.2c2.1,0,4.1,0.4,6,1.3C36,2.8,37.6,4,39,5.6c3.5,4,7.3,7.8,11.3,11.1  c1.7,1.3,2.9,2.9,3.8,4.8c0.9,1.9,1.4,3.9,1.4,6c0,2.2-0.5,4.3-1.4,6.3c-0.9,2-2.3,3.7-4,5h-0.1c-3.8,3.4-7.4,7.1-10.6,11l-0.2,0.3  c-1.3,1.5-3,3-4.8,3.9C32.5,54.6,30.5,55.1,28.6,55.1"/>
            </clipPath>
          </defs>
          <image href="${skuImage}"  clip-path="url(#hxz-variant-picker-drawer)" width="100%" height="100%"></image>
        </svg>
          <i
          class="-hidden group-[.disable]:-block"
          style="
            background: #fff;
            height: 1px;
            position: absolute;
            top: 0;
            left: 0;
            transform: rotate(-45deg) translate(-14px,22px);
            width: 75%;
          "
        ></i>
        </div>
        <div class="-flex-auto">
          <p class="-mb-2 -text-14 -leading-16 -font-semibold">${title}</p>
          <p class="-text-12 -leading-14 -break-words -line-clamp-2 -uppercase">${desc}</p>
        </div>
        <div class="-ml-8 -flex-none -opacity-0 group-[.active]:-opacity-100" style="width: 16px;height: 16px;">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M14.3327 3.6665L5.62435 12.3332L1.66602 8.39377" stroke="#333333" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      `
    }
  }
  close() {
    if (this.filterListener) {
      this.removeEventListener('select-change', this.filterListener)
    }
    this.remove()
  }
  bindEvent() {
    let close = this.querySelector('.drawer-close')
    close.addEventListener('click', () => {
      this.close()
    })
    let mask = this.querySelector('.drawer-mask')
    mask.addEventListener('click', () => {
      this.close()
    })
    let variants = this.querySelectorAll('.variant-btn.-cursor-pointer')
    variants.forEach(variant => {
      variant.addEventListener('click', e => {
        e.stopPropagation()
        this.currentVariant = variant.getAttribute('data-id') || null
        this.eventEmit(
          window.hxzEventMap.productSkuChange(this.eventId),
          this.currentVariant
        )
        this.close()
      })
    })
    if (this.filters && this.filters.length > 1) {
      this.bindFilter()
    }
  }
  createFilterSelect({ name, values }) {
    if (name == 'Shade') return
    return `
      <hxz-select-component
        value="all"
        label="${name}"
        class="-py-2 -px-8"
        direction="down"
        style="background:rgba(46, 50, 56, 0.05);border-radius: 100px;"
      >
        <button class="-flex -items-center expand -justify-between">
          <span class="-text-12 -leading-16 -font-semibold -text-ellipsis -overflow-hidden">
            ${name} : <span class="select-value">ALL</span>
          </span>
          <div
            class="-ml-4 expand-icon -flex-none"
            style="width:13px;height:12px;transition: transform 0.3s ease-in-out;"
          >
            <svg class="-w-full -h-full" width="13" height="12" viewBox="0 0 13 12" fill="none">
              <path d="M12.0655 4.42644C12.2419 4.04171 12.3333 3.67651 12.3333 3.25326L12.0558 3.25326C12.0584 3.68401 11.9506 4.05572 11.7428 4.43303C11.535 4.81033 11.234 5.12813 10.8686 5.35614C10.7868 5.40732 10.3879 5.64555 10.2428 5.73261C10.0685 5.84315 9.90531 5.97028 9.75551 6.11224C9.64549 6.21962 9.30596 6.65704 9.15796 6.98074C8.95682 7.42157 8.6342 7.79594 8.22791 8.05998C7.82162 8.32402 7.34849 8.46679 6.86396 8.47155C6.37944 8.47631 5.90359 8.34287 5.49219 8.08687C5.08078 7.83087 4.75087 7.46291 4.54111 7.02612C4.23099 6.38317 3.70612 5.86866 3.05712 5.57141C2.62102 5.37212 2.24998 5.05386 1.9866 4.6532C1.72322 4.25253 1.57819 3.73264 1.56816 3.25326L1.29059 3.25326C1.29238 3.6534 1.37671 4.07443 1.53831 4.44049C1.69992 4.80655 1.93532 5.13533 2.22978 5.40626L2.23295 5.40864C2.30101 5.4709 2.37225 5.53017 2.44664 5.58645C3.2024 6.22022 3.90648 6.91318 4.55219 7.65876L4.55536 7.65876C4.82523 7.99112 5.16441 8.26057 5.5492 8.44828C5.93399 8.63599 6.35512 8.73745 6.78317 8.74557C7.21123 8.75368 7.6359 8.66825 8.02753 8.49526C8.41916 8.32226 8.7683 8.06587 9.05058 7.74397C9.73521 6.90812 10.4916 6.13368 11.311 5.42948C11.6317 5.15331 11.8891 4.81117 12.0655 4.42644Z" fill="#1C1F23"/>
            </svg>
          </div>
        </button>
        <div class="select-modal -hidden" style="max-height:86px;">
          <div
            class="select-modal-option -w-full -group active"
            data-value="all"
          >
            <div class="-w-full -py-4 -px-12 -flex -items-center -rounded-md -justify-between -text-14 -leading-20 hover:-bg-gray-100 group-[.active]:-bg-primary group-[.active]:-bg-opacity-30">
              <div class="-flex-auto">all</div>
              <div class="-ml-4 -flex-none" style="width:14px;height:14px">
                <svg
                  width="1em"
                  height="1em"
                  fill="#003b4a"
                  aria-hidden="true"
                  viewBox="64 64 896 896"
                  class="-w-full -h-full -hidden group-[.active]:-block"
                >
                  <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path>
                </svg>
              </div>
            </div>
          </div>
          ${values
            .map(
              value => `
            <div class="select-modal-option -w-full -group" data-value="${value}">
              <div class="-w-full -py-4 -px-12 -flex -items-center -rounded-md -justify-between -text-14 -leading-20 hover:-bg-gray-100 group-[.active]:-bg-primary group-[.active]:-bg-opacity-30">
                <div class="-flex-auto -whitespace-nowrap">${value}</div>
                <div class="-ml-4 -flex-none" style="width:14px;height:14px">
                  <svg
                    width="1em"
                    height="1em"
                    fill="#003b4a"
                    aria-hidden="true"
                    viewBox="64 64 896 896"
                    class="-w-full -h-full -hidden group-[.active]:-block"
                  >
                    <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path>
                  </svg>
                </div>
              </div>
            </div>
          `
            )
            .join('')}
        </div>
      </hxz-select-component>
    `
  }
  bindFilter() {
    this.currentFilters = []
    this.filterListener = e => {
      e.stopPropagation()
      let filter = e.detail
      let target = this.currentFilters.find(f => f.label == filter.label)
      if (target) {
        if (target.value == filter.value) return
        target.value = filter.value
      } else {
        this.currentFilters.push(filter)
      }
      this.filtersChange(this.currentFilters, false)
    }
    this.addEventListener('select-change', this.filterListener)
  }
  filtersChange(filters, autoSelect) {
    let filterValue = filters.map(f => f.value).filter(v => v != 'all')
    let btns = this.querySelectorAll('.variant-btn')
    btns.forEach(btn => {
      let options = btn.getAttribute('data-option').split('|')
      let show = filterValue.every(v => options.includes(v))
      if (show) {
        btn.classList.remove('-hidden')
      } else {
        btn.classList.add('-hidden')
      }
    })
  }
}
customElements.define('hxz-variant-picker-drawer', HxzVariantPickerDrawer)

// 通用 select 组件
class HxzSelectComponent extends HTMLElement {
  constructor() {
    super()
    this.label = this.getAttribute('label') || ''
    this.value = this.getAttribute('value') || ''
    this.expanded = false
  }
  connectedCallback() {
    this.bindOptions()
    this.bindToggle()
  }
  bindOptions() {
    let options = this.querySelectorAll('.select-modal-option')
    options.forEach(option => {
      option.addEventListener('click', () => {
        let newValue = option.getAttribute('data-value')
        if (this.value == newValue) return
        this.toggleStyle(this.value, newValue)
        this.value = newValue
        this.querySelector('.select-value').innerText = this.value
        this.dispatchEvent(
          new CustomEvent('select-change', {
            detail: {
              label: this.label,
              value: this.value,
            },
            bubbles: true,
          })
        )
        this.toggle()
      })
    })
  }
  toggle() {
    let expandIcon = this.querySelector('.expand-icon')
    let modal = this.querySelector('.select-modal')
    this.expanded = !this.expanded
    if (this.expanded) {
      modal.classList.remove('-hidden')
      expandIcon.style.transform = 'rotate(180deg)'
      this.listenFullscreenClick()
    } else {
      modal.classList.add('-hidden')
      expandIcon.style.transform = 'rotate(0deg)'
    }
  }
  bindToggle() {
    let modal = this.querySelector('.select-modal')
    let expandBtn = this.querySelector('button.expand')
    if (modal && expandBtn) {
      expandBtn.addEventListener('click', () => {
        this.toggle()
      })
    }
  }
  listenFullscreenClick() {
    const close = event => {
      const rect = this.getBoundingClientRect()
      const modal = this.querySelector('.select-modal').getBoundingClientRect()
      if (modal.width == 0) return
      if (this.checkInBox(event, rect) || this.checkInBox(event, modal)) return
      this.toggle()
      document.removeEventListener('click', close)
    }
    if (this.expanded) {
      document.addEventListener('click', close)
    }
  }
  checkInBox(event, rect) {
    if (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    ) {
      return true
    }
    return false
  }
  toggleStyle(oldValue, newValue) {
    let oldEl = this.querySelector(
      `.select-modal-option[data-value="${oldValue}"]`
    )
    let newEl = this.querySelector(
      `.select-modal-option[data-value="${newValue}"]`
    )
    if (oldEl) {
      oldEl.classList.remove('active')
    }
    if (newEl) {
      newEl.classList.add('active')
    }
  }
}

customElements.define('hxz-select-component', HxzSelectComponent)
